/** 自动生成：pharmaid-crawler2 适配器 config.js */
/* eslint-disable max-len */

export const CRAWL_MODES = {
  "list_page": {
    "label": "栏目列表",
    "summary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "detail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。"
  },
  "api_search": {
    "label": "API 检索",
    "summary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "detail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。"
  },
  "keyword_search": {
    "label": "关键词检索",
    "summary": "在新闻/数据库站点按多个关键词搜索后采集",
    "detail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。"
  },
  "literature_search": {
    "label": "文献检索",
    "summary": "按主题词、必含词、排除词检索学术论文",
    "detail": "如 PubMed、Springer。主题词 OR、必含 AND、排除 NOT 组合成检索式。"
  },
  "portal_keyword": {
    "label": "站内搜索",
    "summary": "在垂直站点用单个关键词搜索（如招标网）",
    "detail": "如千里马招标、BCG 站内搜索。每个栏目通常对应一个搜索词。"
  }
}

export const PARAM_GROUP_LABELS = {
  "ops": "运维",
  "crawl": "抓取量",
  "search": "搜索与过滤",
  "meta": "元数据"
}

export const SOURCE_LIST_ITEMS = [
  {
    "sourceId": "bain_focus_china",
    "name": "贝恩公司-聚焦中国",
    "siteName": "贝恩公司",
    "channelName": "聚焦中国",
    "adapterKey": "bain",
    "adapterDir": "bain",
    "baseUrl": "https://www.bain.cn",
    "country": "Global",
    "url": "https://www.bain.cn/news.php?id=15",
    "category": "贝恩观点-聚焦中国",
    "description": "贝恩公司聚焦中国市场的研究报告和观点文章",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news.php?id=15 · 入库分类标签 4 项（中国市场、消费品…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/news.php?id=15",
      "maxPages": 39,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "中国市场",
        "消费品",
        "零售",
        "私募股权"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bain\",\n  \"parser\": \"bain\",\n  \"difficulty\": 1,\n  \"category\": \"贝恩观点-聚焦中国\",\n  \"description\": \"贝恩公司聚焦中国市场的研究报告和观点文章\",\n  \"listPage\": {\n    \"containerSelector\": \"body\",\n    \"itemSelector\": \"a[href*=\\\"news_info.php?id=\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"h5\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 39,\n      \"startPage\": 1,\n      \"urlPattern\": \"/news.php?id=15&page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h3\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header\",\n        \"footer\",\n        \"nav\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "bain_media_coverage",
    "name": "贝恩公司-媒体报道",
    "siteName": "贝恩公司",
    "channelName": "媒体报道",
    "adapterKey": "bain",
    "adapterDir": "bain",
    "baseUrl": "https://www.bain.cn",
    "country": "Global",
    "url": "https://www.bain.cn/news.php?id=16",
    "category": "贝恩观点-媒体报道",
    "description": "媒体对贝恩公司的报道和专访",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news.php?id=16 · 入库分类标签 3 项（媒体报道、专访…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 5,
      "path": "/news.php?id=16",
      "maxPages": 28,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "媒体报道",
        "专访",
        "新闻"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bain\",\n  \"parser\": \"bain\",\n  \"difficulty\": 1,\n  \"category\": \"贝恩观点-媒体报道\",\n  \"description\": \"媒体对贝恩公司的报道和专访\",\n  \"listPage\": {\n    \"containerSelector\": \"body\",\n    \"itemSelector\": \"a[href*=\\\"news_info.php?id=\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"h5\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 28,\n      \"startPage\": 1,\n      \"urlPattern\": \"/news.php?id=16&page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h3\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header\",\n        \"footer\",\n        \"nav\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "bain_global_view",
    "name": "贝恩公司-全球视野",
    "siteName": "贝恩公司",
    "channelName": "全球视野",
    "adapterKey": "bain",
    "adapterDir": "bain",
    "baseUrl": "https://www.bain.cn",
    "country": "Global",
    "url": "https://www.bain.cn/news.php?id=14",
    "category": "贝恩观点-全球视野",
    "description": "贝恩公司全球视野的研究报告和观点文章",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news.php?id=14 · 入库分类标签 4 项（全球市场、奢侈品…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 2,
      "path": "/news.php?id=14",
      "maxPages": 19,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "全球市场",
        "奢侈品",
        "并购",
        "私募股权"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bain\",\n  \"parser\": \"bain\",\n  \"difficulty\": 1,\n  \"category\": \"贝恩观点-全球视野\",\n  \"description\": \"贝恩公司全球视野的研究报告和观点文章\",\n  \"listPage\": {\n    \"containerSelector\": \"body\",\n    \"itemSelector\": \"a[href*=\\\"news_info.php?id=\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"h5\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 19,\n      \"startPage\": 1,\n      \"urlPattern\": \"/news.php?id=14&page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h3\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header\",\n        \"footer\",\n        \"nav\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "bain_byline_articles",
    "name": "贝恩公司-署名文章",
    "siteName": "贝恩公司",
    "channelName": "署名文章",
    "adapterKey": "bain",
    "adapterDir": "bain",
    "baseUrl": "https://www.bain.cn",
    "country": "Global",
    "url": "https://www.bain.cn/news.php?id=26",
    "category": "贝恩观点-署名文章",
    "description": "贝恩公司专家署名文章",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news.php?id=26 · 入库分类标签 3 项（署名文章、专家观点…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * *",
      "priority": 4,
      "path": "/news.php?id=26",
      "maxPages": 35,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "署名文章",
        "专家观点",
        "行业分析"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bain\",\n  \"parser\": \"bain\",\n  \"difficulty\": 1,\n  \"category\": \"贝恩观点-署名文章\",\n  \"description\": \"贝恩公司专家署名文章\",\n  \"listPage\": {\n    \"containerSelector\": \"body\",\n    \"itemSelector\": \"a[href*=\\\"news_info.php?id=\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"h5\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 35,\n      \"startPage\": 1,\n      \"urlPattern\": \"/news.php?id=26&page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h3\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header\",\n        \"footer\",\n        \"nav\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "bain_ceo_column",
    "name": "贝恩公司-总裁专栏",
    "siteName": "贝恩公司",
    "channelName": "总裁专栏",
    "adapterKey": "bain",
    "adapterDir": "bain",
    "baseUrl": "https://www.bain.cn",
    "country": "Global",
    "url": "https://www.bain.cn/news.php?id=32",
    "category": "贝恩观点-总裁专栏",
    "description": "贝恩公司总裁专栏文章",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news.php?id=32 · 入库分类标签 3 项（总裁、领导力…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * *",
      "priority": 3,
      "path": "/news.php?id=32",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "总裁",
        "领导力",
        "企业战略"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bain\",\n  \"parser\": \"bain\",\n  \"difficulty\": 1,\n  \"category\": \"贝恩观点-总裁专栏\",\n  \"description\": \"贝恩公司总裁专栏文章\",\n  \"listPage\": {\n    \"containerSelector\": \"body\",\n    \"itemSelector\": \"a[href*=\\\"news_info.php?id=\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"h5\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 1,\n      \"urlPattern\": \"/news.php?id=32&page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h3\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header\",\n        \"footer\",\n        \"nav\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "vbdata_medical_intelligence",
    "name": "动脉网情报-医疗器械与AI情报",
    "siteName": "动脉网情报",
    "channelName": "医疗器械与AI情报",
    "adapterKey": "vbdata",
    "adapterDir": "vbdata",
    "baseUrl": "https://www.vbdata.cn",
    "country": "CN",
    "url": "https://www.vbdata.cn/intelList",
    "category": "动脉网-医疗器械",
    "description": "诊断设备、治疗设备、数字疗法、医疗机器人、医疗人工智能",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/intelList · 标签映射（5 项） · 标签 ID 5 项（833、835…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tagMapping",
        "group": "search",
        "type": "json",
        "label": "标签映射",
        "specific": true,
        "description": "标签映射"
      },
      {
        "key": "tagIds",
        "group": "search",
        "type": "json",
        "label": "标签 ID",
        "specific": true,
        "description": "标签 ID"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 1,
      "path": "/intelList",
      "maxPages": 500,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 3
      },
      "tagMapping": {
        "诊断设备": 833,
        "治疗设备": 835,
        "数字疗法": 846,
        "医疗机器人": 853,
        "医疗人工智能": 1612
      },
      "tagIds": [
        833,
        835,
        846,
        853,
        1612
      ],
      "tags": [
        "诊断设备",
        "治疗设备",
        "数字疗法",
        "医疗机器人",
        "医疗人工智能"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"vbdata\",\n  \"parser\": \"vbdata\",\n  \"difficulty\": 3,\n  \"category\": \"动脉网-医疗器械\",\n  \"description\": \"诊断设备、治疗设备、数字疗法、医疗机器人、医疗人工智能\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"api\",\n      \"startPage\": 1,\n      \"perPage\": 20,\n      \"maxPages\": 500\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"api\",\n    \"skipFetch\": true\n  }\n}"
  },
  {
    "sourceId": "nhc_czyjs",
    "name": "国家卫生健康委员会-财政预决算",
    "siteName": "国家卫生健康委员会",
    "channelName": "财政预决算",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/czyjs/",
    "category": "政策-财政预决算",
    "description": "财政预算决算信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/czyjs/ · 入库分类标签：财政预算、财务公开",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 1 * *",
      "priority": 6,
      "path": "/wjw/czyjs/",
      "maxPages": 100,
      "tags": [
        "财政预算",
        "财务公开"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政策-财政预决算\",\n  \"description\": \"财政预算决算信息\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_gztz",
    "name": "国家卫生健康委员会-工作通知",
    "siteName": "国家卫生健康委员会",
    "channelName": "工作通知",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/gztz/",
    "category": "政策-工作通知",
    "description": "工作通知公告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/gztz/ · 入库分类标签：工作通知、通知公告",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 3,
      "path": "/wjw/gztz/",
      "maxPages": 100,
      "tags": [
        "工作通知",
        "通知公告"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政策-工作通知\",\n  \"description\": \"工作通知公告\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_gwywj",
    "name": "国家卫生健康委员会-国务院文件",
    "siteName": "国家卫生健康委员会",
    "channelName": "国务院文件",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/bgt/gwywj2/",
    "category": "政策-国务院文件",
    "description": "国务院相关文件",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/bgt/gwywj2/ · 入库分类标签：国务院文件、政策法规",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/bgt/gwywj2/",
      "maxPages": 100,
      "tags": [
        "国务院文件",
        "政策法规"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政策-国务院文件\",\n  \"description\": \"国务院相关文件\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_jiany",
    "name": "国家卫生健康委员会-建议（人大）",
    "siteName": "国家卫生健康委员会",
    "channelName": "建议（人大）",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/jiany/",
    "category": "建议提案-人大建议",
    "description": "人大代表建议答复",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/jiany/ · 入库分类标签：人大建议、建议答复",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 2",
      "priority": 4,
      "path": "/wjw/jiany/",
      "maxPages": 100,
      "tags": [
        "人大建议",
        "建议答复"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"proposal\",\n  \"category\": \"建议提案-人大建议\",\n  \"description\": \"人大代表建议答复\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_mtbd",
    "name": "国家卫生健康委员会-媒体报道",
    "siteName": "国家卫生健康委员会",
    "channelName": "媒体报道",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/mtbd/",
    "category": "新闻-媒体报道",
    "description": "媒体对卫健委工作的报道",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/mtbd/ · 入库分类标签：媒体报道、新闻报道",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 3,
      "path": "/wjw/mtbd/",
      "maxPages": 100,
      "tags": [
        "媒体报道",
        "新闻报道"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"新闻-媒体报道\",\n  \"description\": \"媒体对卫健委工作的报道\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_tia",
    "name": "国家卫生健康委员会-提案（政协）",
    "siteName": "国家卫生健康委员会",
    "channelName": "提案（政协）",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/tia/",
    "category": "建议提案-政协提案",
    "description": "政协委员提案答复",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/tia/ · 入库分类标签：政协提案、提案答复",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 2",
      "priority": 4,
      "path": "/wjw/tia/",
      "maxPages": 100,
      "tags": [
        "政协提案",
        "提案答复"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"proposal\",\n  \"category\": \"建议提案-政协提案\",\n  \"description\": \"政协委员提案答复\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_wnsj",
    "name": "国家卫生健康委员会-委内要事",
    "siteName": "国家卫生健康委员会",
    "channelName": "委内要事",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/wnsj/",
    "category": "新闻-委内要事",
    "description": "国家卫健委委内要事",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/wnsj/ · 入库分类标签：委内要事、领导活动",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 2,
      "path": "/wjw/wnsj/",
      "maxPages": 100,
      "tags": [
        "委内要事",
        "领导活动"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"新闻-委内要事\",\n  \"description\": \"国家卫健委委内要事\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_xwdt",
    "name": "国家卫生健康委员会-新闻动态",
    "siteName": "国家卫生健康委员会",
    "channelName": "新闻动态",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/xwdt/",
    "category": "新闻-新闻动态",
    "description": "国家卫健委新闻动态",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/xwdt/ · 入库分类标签 3 项（新闻动态、卫生健康…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/wjw/xwdt/",
      "maxPages": 100,
      "tags": [
        "新闻动态",
        "卫生健康",
        "政策新闻"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"新闻-新闻动态\",\n  \"description\": \"国家卫健委新闻动态\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_zcfg",
    "name": "国家卫生健康委员会-政策法规",
    "siteName": "国家卫生健康委员会",
    "channelName": "政策法规",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/zcfg/",
    "category": "政策-政策法规",
    "description": "政策法规解读",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/zcfg/ · 入库分类标签：政策法规、政策解读",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 2,
      "path": "/wjw/zcfg/",
      "maxPages": 100,
      "tags": [
        "政策法规",
        "政策解读"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政策-政策法规\",\n  \"description\": \"政策法规解读\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhc_zfcg",
    "name": "国家卫生健康委员会-政府采购",
    "siteName": "国家卫生健康委员会",
    "channelName": "政府采购",
    "adapterKey": "nhc",
    "adapterDir": "nhc",
    "baseUrl": "https://www.nhc.gov.cn",
    "country": "CN",
    "url": "https://www.nhc.gov.cn/wjw/zfcg/",
    "category": "政策-政府采购",
    "description": "政府采购信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/wjw/zfcg/ · 入库分类标签：政府采购、招标采购",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 5,
      "path": "/wjw/zfcg/",
      "maxPages": 100,
      "tags": [
        "政府采购",
        "招标采购"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhc\",\n  \"parser\": \"nhc\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政策-政府采购\",\n  \"description\": \"政府采购信息\",\n  \"listPage\": {\n    \"itemSelector\": \"ul li a[href]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1, .title\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content, #zoom\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"publishDate\": \"发布时间\",\n      \"source\": \"来源\",\n      \"docNums\": \"文号\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\",\n        \".nav\",\n        \".breadcrumb\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_fgwj",
    "name": "国家药品监督管理局-医疗器械法规文件",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械法规文件",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/ylqx/ylqxfgwj/index.html",
    "category": "器械资讯-法规文件",
    "description": "医疗器械相关法规、规范性文件",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/ylqx/ylqxfgwj/index.htm… · 入库分类标签 5 项（法规、文件…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 2",
      "priority": 2,
      "path": "/ylqx/ylqxfgwj/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "法规",
        "文件",
        "规范",
        "通知",
        "指导原则"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-法规文件\",\n  \"description\": \"医疗器械相关法规、规范性文件\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/ylqx/ylqxfgwj/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_fxjc",
    "name": "国家药品监督管理局-医疗器械飞行检查",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械飞行检查",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/xxgk/fxjzh/ylqxfxjch/index.html",
    "category": "器械资讯-飞行检查",
    "description": "医疗器械生产企业飞行检查结果",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/xxgk/fxjzh/ylqxfxjch/in… · 入库分类标签 5 项（飞行检查、检查…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 1 * * 3",
      "priority": 1,
      "path": "/xxgk/fxjzh/ylqxfxjch/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "飞行检查",
        "检查",
        "通告",
        "整改",
        "停产"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-飞行检查\",\n  \"description\": \"医疗器械生产企业飞行检查结果\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/xxgk/fxjzh/ylqxfxjch/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_ggtg",
    "name": "国家药品监督管理局-医疗器械公告通告",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械公告通告",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/ylqx/ylqxggtg/index.html",
    "category": "器械资讯-公告通告",
    "description": "医疗器械注册批准、标准发布等公告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/ylqx/ylqxggtg/index.htm… · 入库分类标签 5 项（公告、通告…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * 1",
      "priority": 1,
      "path": "/ylqx/ylqxggtg/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "公告",
        "通告",
        "注册",
        "批准",
        "标准"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-公告通告\",\n  \"description\": \"医疗器械注册批准、标准发布等公告\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/ylqx/ylqxggtg/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_jgdt",
    "name": "国家药品监督管理局-医疗器械监管工作",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械监管工作",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/ylqx/ylqxjgdt/index.html",
    "category": "器械资讯-监管动态",
    "description": "国家药监局医疗器械监管工作动态",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/ylqx/ylqxjgdt/index.htm… · 入库分类标签 4 项（监管、工作…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 1 * * 1",
      "priority": 1,
      "path": "/ylqx/ylqxjgdt/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "监管",
        "工作",
        "动态",
        "医疗器械"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-监管动态\",\n  \"description\": \"国家药监局医疗器械监管工作动态\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/ylqx/ylqxjgdt/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_kpzs",
    "name": "国家药品监督管理局-医疗器械科普",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械科普",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/xxgk/kpzhsh/kpzhshylqx/index.html",
    "category": "器械资讯-科普知识",
    "description": "医疗器械科普知识",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/xxgk/kpzhsh/kpzhshylqx/… · 入库分类标签 4 项（科普、会客厅…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 3",
      "priority": 3,
      "path": "/xxgk/kpzhsh/kpzhshylqx/index.html",
      "maxPages": 3,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科普",
        "会客厅",
        "健康",
        "知识"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-科普知识\",\n  \"description\": \"医疗器械科普知识\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 3,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/xxgk/kpzhsh/kpzhshylqx/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_zhh",
    "name": "国家药品监督管理局-医疗器械召回",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械召回",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/xxgk/chpzhh/ylqxzhh/index.html",
    "category": "器械资讯-产品召回",
    "description": "医疗器械产品主动召回信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/xxgk/chpzhh/ylqxzhh/ind… · 入库分类标签 4 项（召回、主动召回…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * 3",
      "priority": 1,
      "path": "/xxgk/chpzhh/ylqxzhh/index.html",
      "maxPages": 20,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "召回",
        "主动召回",
        "境外",
        "医疗器械"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-产品召回\",\n  \"description\": \"医疗器械产品主动召回信息\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 20,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/xxgk/chpzhh/ylqxzhh/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nmpa_zcjd",
    "name": "国家药品监督管理局-医疗器械政策解读",
    "siteName": "国家药品监督管理局",
    "channelName": "医疗器械政策解读",
    "adapterKey": "nmpa",
    "adapterDir": "nmpa",
    "baseUrl": "https://www.nmpa.gov.cn",
    "country": "CN",
    "url": "https://www.nmpa.gov.cn/ylqx/ylqxzhcjd/index.html",
    "category": "器械资讯-政策解读",
    "description": "医疗器械政策法规解读",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/ylqx/ylqxzhcjd/index.ht… · 入库分类标签 4 项（解读、政策…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 2",
      "priority": 2,
      "path": "/ylqx/ylqxzhcjd/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "解读",
        "政策",
        "图解",
        "药你知道"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nmpa\",\n  \"parser\": \"nmpa\",\n  \"difficulty\": 1,\n  \"category\": \"器械资讯-政策解读\",\n  \"description\": \"医疗器械政策法规解读\",\n  \"listPage\": {\n    \"containerSelector\": \".xxgk-list, .list-con, ul.list\",\n    \"itemSelector\": \"li, .list-item\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/ylqx/ylqxzhcjd/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".xxgk-title, .article-title, h1.title, .TRS_Editor h1\",\n    \"dateSelector\": \".sj, .publish-date, .article-info span:first-child, .info-date\",\n    \"contentSelector\": \".TRS_Editor, .xxgk-cnt, .article-content, .content-main\",\n    \"sourceSelector\": \".ly, .source, .article-info .source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_budget_115",
    "name": "国家医疗保障局-部门预算",
    "siteName": "国家医疗保障局",
    "channelName": "部门预算",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col115/index.html",
    "category": "政府公开-部门预算",
    "description": "部门预算决算信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col115/index.html · 入库分类标签 3 项（部门预算、财务公开…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 1 * *",
      "priority": 7,
      "path": "/col/col115/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "部门预算",
        "财务公开",
        "预算决算"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-部门预算\",\n  \"description\": \"部门预算决算信息\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_news_15",
    "name": "国家医疗保障局-地方医保动态",
    "siteName": "国家医疗保障局",
    "channelName": "地方医保动态",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col15/index.html",
    "category": "医保新闻-地方动态",
    "description": "各地医保部门动态新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col15/index.html · 入库分类标签 3 项（地方医保、省市医保…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 2,
      "path": "/col/col15/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "地方医保",
        "省市医保",
        "医保动态"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"医保新闻-地方动态\",\n  \"description\": \"各地医保部门动态新闻\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_service_114",
    "name": "国家医疗保障局-公共服务",
    "siteName": "国家医疗保障局",
    "channelName": "公共服务",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col114/index.html",
    "category": "政府公开-公共服务",
    "description": "医保公共服务信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col114/index.html · 入库分类标签 3 项（公共服务、办事指南…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * *",
      "priority": 6,
      "path": "/col/col114/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "公共服务",
        "办事指南",
        "服务信息"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-公共服务\",\n  \"description\": \"医保公共服务信息\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_proposal_110",
    "name": "国家医疗保障局-建议提案",
    "siteName": "国家医疗保障局",
    "channelName": "建议提案",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col110/index.html",
    "category": "政府公开-建议提案",
    "description": "人大代表建议和政协委员提案答复",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col110/index.html · 入库分类标签 3 项（建议提案、人大建议…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 3,
      "path": "/col/col110/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "建议提案",
        "人大建议",
        "政协提案"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-建议提案\",\n  \"description\": \"人大代表建议和政协委员提案答复\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_news_46",
    "name": "国家医疗保障局-媒体报道",
    "siteName": "国家医疗保障局",
    "channelName": "媒体报道",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col46/index.html",
    "category": "医保新闻-媒体报道",
    "description": "媒体对医保工作的报道",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col46/index.html · 入库分类标签 3 项（媒体报道、新闻报道…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 3,
      "path": "/col/col46/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "媒体报道",
        "新闻报道",
        "医保新闻"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"医保新闻-媒体报道\",\n  \"description\": \"媒体对医保工作的报道\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_notice_109",
    "name": "国家医疗保障局-通知公告",
    "siteName": "国家医疗保障局",
    "channelName": "通知公告",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col109/index.html",
    "category": "政府公开-通知公告",
    "description": "国家医保局通知公告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col109/index.html · 入库分类标签 3 项（通知、公告…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 2,
      "path": "/col/col109/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "通知",
        "公告",
        "医保通知"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-通知公告\",\n  \"description\": \"国家医保局通知公告\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_news_14",
    "name": "国家医疗保障局-医保动态",
    "siteName": "国家医疗保障局",
    "channelName": "医保动态",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col14/index.html",
    "category": "医保新闻-医保动态",
    "description": "国家医保局医保动态新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col14/index.html · 入库分类标签 3 项（医保动态、医疗保障…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/col/col14/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "医保动态",
        "医疗保障",
        "政策新闻"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"news\",\n  \"category\": \"医保新闻-医保动态\",\n  \"description\": \"国家医保局医保动态新闻\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_opinion_113",
    "name": "国家医疗保障局-征求意见",
    "siteName": "国家医疗保障局",
    "channelName": "征求意见",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col113/index.html",
    "category": "政府公开-征求意见",
    "description": "政策法规征求意见",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col113/index.html · 入库分类标签 3 项（征求意见、公开征求…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 5,
      "path": "/col/col113/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "征求意见",
        "公开征求",
        "意见反馈"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-征求意见\",\n  \"description\": \"政策法规征求意见\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_policy_104",
    "name": "国家医疗保障局-政策法规",
    "siteName": "国家医疗保障局",
    "channelName": "政策法规",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col104/index.html",
    "category": "政府公开-政策法规",
    "description": "国家医保局政策法规文件",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col104/index.html · 入库分类标签 3 项（政策法规、医保政策…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/col/col104/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "政策法规",
        "医保政策",
        "规范性文件"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-政策法规\",\n  \"description\": \"国家医保局政策法规文件\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nhsa_annual_123",
    "name": "国家医疗保障局-政府信息公开年报",
    "siteName": "国家医疗保障局",
    "channelName": "政府信息公开年报",
    "adapterKey": "nhsa",
    "adapterDir": "nhsa",
    "baseUrl": "https://www.nhsa.gov.cn",
    "country": "CN",
    "url": "https://www.nhsa.gov.cn/col/col123/index.html",
    "category": "政府公开-年报",
    "description": "政府信息公开工作年度报告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/col/col123/index.html · 入库分类标签 3 项（年报、政府信息公开…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 1 * *",
      "priority": 4,
      "path": "/col/col123/index.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "年报",
        "政府信息公开",
        "工作报告"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nhsa\",\n  \"parser\": \"nhsa\",\n  \"difficulty\": 2,\n  \"type\": \"policy\",\n  \"category\": \"政府公开-年报\",\n  \"description\": \"政府信息公开工作年度报告\",\n  \"listPage\": {\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a[href*=\\\"/art/\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"paramName\": \"pageNum\",\n      \"startPage\": 1,\n      \"perPage\": 15,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2, .article-title, .title\",\n    \"contentSelector\": \".article-content, .content, .TRS_Editor\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metaSelectors\": {\n      \"indexNumber\": \"索引号\",\n      \"docNumber\": \"发文字号\",\n      \"publisher\": \"发布机构\",\n      \"publishDate\": \"发布日期\"\n    },\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\",\n      \".ofd\",\n      \".txt\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\",\n        \".footer\",\n        \".header\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_fdzdgknr",
    "name": "科学技术部-法定主动公开内容",
    "siteName": "科学技术部",
    "channelName": "法定主动公开内容",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/xxgk/xinxifenlei/fdzdgknr/",
    "category": "科技政策-法定主动公开内容",
    "description": "科技部法定主动公开内容（政策、规章、统计报告等）",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/xxgk/xinxifenlei/fdzdgk… · 入库分类标签 3 项（科技政策、法规…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 1",
      "priority": 1,
      "path": "/xxgk/xinxifenlei/fdzdgknr/",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科技政策",
        "法规",
        "公开"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-法定主动公开内容\",\n  \"description\": \"科技部法定主动公开内容（政策、规章、统计报告等）\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 100,\n      \"startPage\": 0,\n      \"urlPattern\": \"/xxgk/xinxifenlei/fdzdgknr/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_gjkjflfg",
    "name": "科学技术部-国家科技法律法规",
    "siteName": "科学技术部",
    "channelName": "国家科技法律法规",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/gjkjflfg/",
    "category": "科技政策-国家科技法律法规",
    "description": "国家科技相关法律法规",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/gjkjflfg/ · 入库分类标签 3 项（法律、法规…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 2",
      "priority": 2,
      "path": "/satp/gjkjflfg/",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "法律",
        "法规",
        "科技"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-国家科技法律法规\",\n  \"description\": \"国家科技相关法律法规\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/gjkjflfg/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzc_gjkjhz",
    "name": "科学技术部-科技政策-国际科技合作",
    "siteName": "科学技术部",
    "channelName": "科技政策-国际科技合作",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzc/gjkjhz/",
    "category": "科技政策-国际科技合作",
    "description": "国际科技合作相关政策",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzc/gjkjhz/ · 入库分类标签：国际合作、科技合作",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 6",
      "priority": 6,
      "path": "/satp/kjzc/gjkjhz/",
      "maxPages": 3,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "国际合作",
        "科技合作"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-国际科技合作\",\n  \"description\": \"国际科技合作相关政策\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 3,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzc/gjkjhz/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzc_kjjhgl",
    "name": "科学技术部-科技政策-科技计划管理",
    "siteName": "科学技术部",
    "channelName": "科技政策-科技计划管理",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzc/kjjhgl/",
    "category": "科技政策-科技计划管理",
    "description": "科技计划管理相关政策",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzc/kjjhgl/ · 入库分类标签：科技计划、管理",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 4",
      "priority": 4,
      "path": "/satp/kjzc/kjjhgl/",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科技计划",
        "管理"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-科技计划管理\",\n  \"description\": \"科技计划管理相关政策\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzc/kjjhgl/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzc_kjjdycxjs",
    "name": "科学技术部-科技政策-科技监督与诚信建设",
    "siteName": "科学技术部",
    "channelName": "科技政策-科技监督与诚信建设",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzc/kjjdycxjs/",
    "category": "科技政策-科技监督与诚信建设",
    "description": "科技监督与诚信建设相关政策",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzc/kjjdycxjs/ · 入库分类标签 3 项（科技监督、诚信建设…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 0",
      "priority": 7,
      "path": "/satp/kjzc/kjjdycxjs/",
      "maxPages": 3,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科技监督",
        "诚信建设",
        "学术诚信"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-科技监督与诚信建设\",\n  \"description\": \"科技监督与诚信建设相关政策\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 3,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzc/kjjdycxjs/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzc_kjjl",
    "name": "科学技术部-科技政策-科技奖励",
    "siteName": "科学技术部",
    "channelName": "科技政策-科技奖励",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzc/kjjl/",
    "category": "科技政策-科技奖励",
    "description": "科技奖励相关政策",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzc/kjjl/ · 入库分类标签：科技奖励、奖励",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 5",
      "priority": 5,
      "path": "/satp/kjzc/kjjl/",
      "maxPages": 3,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科技奖励",
        "奖励"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-科技奖励\",\n  \"description\": \"科技奖励相关政策\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 3,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzc/kjjl/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzc_zh",
    "name": "科学技术部-科技政策-综合",
    "siteName": "科学技术部",
    "channelName": "科技政策-综合",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzc/zh/",
    "category": "科技政策-综合",
    "description": "综合性科技政策",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzc/zh/ · 入库分类标签：科技政策、综合",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 3",
      "priority": 3,
      "path": "/satp/kjzc/zh/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "科技政策",
        "综合"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-综合\",\n  \"description\": \"综合性科技政策\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzc/zh/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "most_kjzcjd",
    "name": "科学技术部-科技政策解读",
    "siteName": "科学技术部",
    "channelName": "科技政策解读",
    "adapterKey": "most",
    "adapterDir": "most",
    "baseUrl": "https://www.most.gov.cn",
    "country": "CN",
    "url": "https://www.most.gov.cn/satp/kjzcjd/",
    "category": "科技政策-科技政策解读",
    "description": "科技政策解读与说明",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/satp/kjzcjd/ · 入库分类标签：政策解读、解读",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 8,
      "path": "/satp/kjzcjd/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "政策解读",
        "解读"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"most\",\n  \"parser\": \"most\",\n  \"difficulty\": 2,\n  \"category\": \"科技政策-科技政策解读\",\n  \"description\": \"科技政策解读与说明\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href]\",\n    \"datePattern\": \"/(\\\\d{4}[-年]\\\\d{2}[-月]\\\\d{2}日?)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPattern\": \"/satp/kjzcjd/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".article-title, h2, h1\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".TRS_Editor, .article-content, .content\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"metadata\": {\n      \"docNumLabel\": \"索 引 号\",\n      \"sourceLabel\": \"发文机构\",\n      \"publishDateLabel\": \"发布日期\",\n      \"effectiveDateLabel\": \"成文日期\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".div_qrcode\",\n        \"#qrcode\",\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "qianlima_medical-devices",
    "name": "千里马招标网-Medical Devices",
    "siteName": "千里马招标网",
    "channelName": "Medical Devices",
    "adapterKey": "qianlima",
    "adapterDir": "qianlima",
    "baseUrl": "https://vip.qianlima.com",
    "country": "CN",
    "url": "https://vip.qianlima.com",
    "category": "",
    "description": "",
    "crawlMode": "portal_keyword",
    "crawlModeLabel": "站内搜索",
    "crawlModeSummary": "在垂直站点用单个关键词搜索（如招标网）",
    "crawlModeDetail": "如千里马招标、BCG 站内搜索。每个栏目通常对应一个搜索词。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "keyword",
      "maxPages"
    ],
    "configSummary": "搜索关键词：医疗器械 · 入库分类标签：医疗器械",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "keyword",
        "group": "search",
        "type": "string",
        "label": "搜索关键词",
        "specific": true,
        "description": "搜索关键词"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 4",
      "priority": 5,
      "maxPages": 10,
      "keyword": "医疗器械",
      "tags": [
        "医疗器械"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"qianlima\",\n  \"difficulty\": 2,\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"maxPages\": 10\n    }\n  },\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "caivd_hangye",
    "name": "全国体外诊断网-行业资讯",
    "siteName": "全国体外诊断网",
    "channelName": "行业资讯",
    "adapterKey": "caivd",
    "adapterDir": "caivd",
    "baseUrl": "https://www.caivd-org.cn",
    "country": "Global",
    "url": "https://www.caivd-org.cn/hangye.asp",
    "category": "IVD-行业资讯",
    "description": "IVD行业综合资讯，包含业界动态、医疗改革、仪器试剂",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/hangye.asp · 入库分类标签 5 项（IVD、体外诊断…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 1,
      "path": "/hangye.asp",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "IVD",
        "体外诊断",
        "检验医学",
        "分子诊断",
        "生化免疫"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"caivd\",\n  \"parser\": \"caivd\",\n  \"difficulty\": 1,\n  \"category\": \"IVD-行业资讯\",\n  \"description\": \"IVD行业综合资讯，包含业界动态、医疗改革、仪器试剂\",\n  \"listPage\": {\n    \"itemSelector\": \".newslist ul li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"dt\",\n    \"dateSelector\": \".time\",\n    \"summarySelector\": \".news_info\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"queryParam\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h4\",\n    \"datePattern\": \"/更新时间[：:](\\\\d{4}\\\\/\\\\d{1,2}\\\\/\\\\d{1,2})/\",\n    \"viewCountPattern\": \"/浏览次数[：:](\\\\d+)/\",\n    \"contentSelector\": \".newscontent\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".nrnav\",\n        \".listloc\",\n        \"h4\",\n        \".news_ico\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "caivd_fagui",
    "name": "全国体外诊断网-政策法规",
    "siteName": "全国体外诊断网",
    "channelName": "政策法规",
    "adapterKey": "caivd",
    "adapterDir": "caivd",
    "baseUrl": "https://www.caivd-org.cn",
    "country": "Global",
    "url": "https://www.caivd-org.cn/fagui.asp",
    "category": "IVD-政策法规",
    "description": "IVD政策法规，包含政策法规、相关标准、指导原则、注册备案、专家共识",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/fagui.asp · 入库分类标签 5 项（政策法规、标准…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 1,
      "path": "/fagui.asp",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "政策法规",
        "标准",
        "指导原则",
        "注册备案",
        "专家共识"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"caivd\",\n  \"parser\": \"caivd\",\n  \"difficulty\": 1,\n  \"category\": \"IVD-政策法规\",\n  \"description\": \"IVD政策法规，包含政策法规、相关标准、指导原则、注册备案、专家共识\",\n  \"listPage\": {\n    \"itemSelector\": \".newslist ul li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"dt\",\n    \"dateSelector\": \".time\",\n    \"summarySelector\": \".news_info\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"queryParam\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h4\",\n    \"datePattern\": \"/更新时间[：:](\\\\d{4}\\\\/\\\\d{1,2}\\\\/\\\\d{1,2})/\",\n    \"viewCountPattern\": \"/浏览次数[：:](\\\\d+)/\",\n    \"contentSelector\": \".newscontent\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".nrnav\",\n        \".listloc\",\n        \"h4\",\n        \".news_ico\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_dasai",
    "name": "医疗器械创新网-创新创业大赛",
    "siteName": "医疗器械创新网",
    "channelName": "创新创业大赛",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/dasai.html",
    "category": "医械资讯-创新大赛",
    "description": "中国医疗器械创新创业大赛相关报道",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/dasai.html · 入库分类标签 3 项（创新创业大赛、赛事报道…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 5,
      "path": "/article/dasai.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "创新创业大赛",
        "赛事报道",
        "获奖项目"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-创新大赛\",\n  \"description\": \"中国医疗器械创新创业大赛相关报道\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_company",
    "name": "医疗器械创新网-创新企业/机构",
    "siteName": "医疗器械创新网",
    "channelName": "创新企业/机构",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/company.html",
    "category": "医械资讯-创新企业",
    "description": "医疗器械创新企业和机构动态",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/company.html · 入库分类标签 3 项（创新企业、医械公司…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 4,
      "path": "/article/company.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "创新企业",
        "医械公司",
        "投融资"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-创新企业\",\n  \"description\": \"医疗器械创新企业和机构动态\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_product",
    "name": "医疗器械创新网-技术/产品",
    "siteName": "医疗器械创新网",
    "channelName": "技术/产品",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/product.html",
    "category": "医械资讯-技术产品",
    "description": "医疗器械技术创新和产品信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/product.html · 入库分类标签 3 项（技术创新、产品发布…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 3,
      "path": "/article/product.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "技术创新",
        "产品发布",
        "研发动态"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-技术产品\",\n  \"description\": \"医疗器械技术创新和产品信息\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_news",
    "name": "医疗器械创新网-行业资讯",
    "siteName": "医疗器械创新网",
    "channelName": "行业资讯",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/news.html",
    "category": "医械资讯-行业资讯",
    "description": "医疗器械行业综合新闻资讯",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/news.html · 入库分类标签 3 项（医疗器械、行业资讯…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/article/news.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "医疗器械",
        "行业资讯",
        "创新动态"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-行业资讯\",\n  \"description\": \"医疗器械行业综合新闻资讯\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_policy",
    "name": "医疗器械创新网-政策法规",
    "siteName": "医疗器械创新网",
    "channelName": "政策法规",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/policy.html",
    "category": "医械资讯-政策法规",
    "description": "医疗器械相关政策法规信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/policy.html · 入库分类标签 3 项（政策法规、医疗器械监管…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 2,
      "path": "/article/policy.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "政策法规",
        "医疗器械监管",
        "行业规范"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-政策法规\",\n  \"description\": \"医疗器械相关政策法规信息\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "innomd_zhuanfang",
    "name": "医疗器械创新网-专访",
    "siteName": "医疗器械创新网",
    "channelName": "专访",
    "adapterKey": "innomd",
    "adapterDir": "innomd",
    "baseUrl": "https://www.innomd.org",
    "country": "CN",
    "url": "https://www.innomd.org/article/zhuanfang.html",
    "category": "医械资讯-专访",
    "description": "医疗器械行业人物专访",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/article/zhuanfang.html · 入库分类标签 3 项（人物专访、企业专访…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 6,
      "path": "/article/zhuanfang.html",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "人物专访",
        "企业专访",
        "行业领袖"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"innomd\",\n  \"parser\": \"innomd\",\n  \"difficulty\": 2,\n  \"category\": \"医械资讯-专访\",\n  \"description\": \"医疗器械行业人物专访\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/article/\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2})/\",\n    \"dayPattern\": \"/^(\\\\d{1,2})$/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"query\",\n      \"paramName\": \"page\",\n      \"idParamName\": \"id\",\n      \"startPage\": 1,\n      \"perPage\": 12,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"datePattern\": \"/日期[：:]\\\\s*(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"viewCountPattern\": \"/浏览量[：:]\\\\s*(\\\\d+)/\",\n    \"contentSelector\": \".article-content, .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmde_shpbg",
    "name": "医疗器械技术审评中心-审评报告",
    "siteName": "医疗器械技术审评中心",
    "channelName": "审评报告",
    "adapterKey": "cmde",
    "adapterDir": "cmde",
    "baseUrl": "https://www.cmde.org.cn",
    "country": "CN",
    "url": "https://www.cmde.org.cn/xwdt/shpbg/index.html",
    "category": "器械资讯-审评报告",
    "description": "医疗器械产品审评报告（PDF附件）",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/xwdt/shpbg/index.html · 入库分类标签 3 项（审评报告、医疗器械…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * 1",
      "priority": 1,
      "path": "/xwdt/shpbg/index.html",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "审评报告",
        "医疗器械",
        "注册"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmde\",\n  \"parser\": \"cmde\",\n  \"difficulty\": 2,\n  \"category\": \"器械资讯-审评报告\",\n  \"description\": \"医疗器械产品审评报告（PDF附件）\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/\\\\((\\\\d{4}-\\\\d{2}-\\\\d{2})\\\\)/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 0,\n      \"urlPatternSuffix\": \"/index_{page}.html\",\n      \"nextSelector\": \"a:contains(\\\"下一页\\\")\",\n      \"totalSelector\": \".page-info\",\n      \"urlPattern\": \"/xwdt/shpbg/index_{page}.html\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"dateSelector\": \".article-info, .meta\",\n    \"contentSelector\": \".article-content, .content, .text\",\n    \"sourceSelector\": \".source\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \".share-box\",\n        \".related-links\",\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".ad-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_policy_22",
    "name": "中国生物技术发展中心-调研报告",
    "siteName": "中国生物技术发展中心",
    "channelName": "调研报告",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/22",
    "category": "政策法规-调研报告",
    "description": "生物技术调研报告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/22 · 入库分类标签 3 项（调研报告、研究报告…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 3,
      "path": "/News/Index/22",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "调研报告",
        "研究报告",
        "产业分析"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"政策法规-调研报告\",\n  \"description\": \"生物技术调研报告\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=22$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_policy_21",
    "name": "中国生物技术发展中心-发展规划",
    "siteName": "中国生物技术发展中心",
    "channelName": "发展规划",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/21",
    "category": "政策法规-发展规划",
    "description": "生物技术发展规划",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/21 · 入库分类标签 3 项（发展规划、战略规划…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 2,
      "path": "/News/Index/21",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "发展规划",
        "战略规划",
        "生物经济"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"政策法规-发展规划\",\n  \"description\": \"生物技术发展规划\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=21$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_policy_20",
    "name": "中国生物技术发展中心-管理条例",
    "siteName": "中国生物技术发展中心",
    "channelName": "管理条例",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/20",
    "category": "政策法规-管理条例",
    "description": "生物技术相关管理条例",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/20 · 入库分类标签 3 项（管理条例、政策法规…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 1,
      "path": "/News/Index/20",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "管理条例",
        "政策法规",
        "生物安全"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"政策法规-管理条例\",\n  \"description\": \"生物技术相关管理条例\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=20$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_news_17",
    "name": "中国生物技术发展中心-国际新闻",
    "siteName": "中国生物技术发展中心",
    "channelName": "国际新闻",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/17",
    "category": "新闻动态-国际新闻",
    "description": "国际生物技术与生命科学新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/17 · 入库分类标签 3 项（国际新闻、生物技术…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 3,
      "path": "/News/Index/17",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "国际新闻",
        "生物技术",
        "生命科学"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"新闻动态-国际新闻\",\n  \"description\": \"国际生物技术与生命科学新闻\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=17$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_news_16",
    "name": "中国生物技术发展中心-国内新闻",
    "siteName": "中国生物技术发展中心",
    "channelName": "国内新闻",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/16",
    "category": "新闻动态-国内新闻",
    "description": "国内生物技术与生命科学新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/16 · 入库分类标签 3 项（国内新闻、生物技术…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 2,
      "path": "/News/Index/16",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "国内新闻",
        "生物技术",
        "生命科学"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"新闻动态-国内新闻\",\n  \"description\": \"国内生物技术与生命科学新闻\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=16$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_notice",
    "name": "中国生物技术发展中心-通知通告",
    "siteName": "中国生物技术发展中心",
    "channelName": "通知通告",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/Notice/",
    "category": "通知通告",
    "description": "中国生物技术发展中心通知通告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/Notice/ · 入库分类标签 5 项（通知、通告…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/Notice/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "通知",
        "通告",
        "公告",
        "招聘",
        "征集"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"通知通告\",\n  \"description\": \"中国生物技术发展中心通知通告\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/Notice/Index/channel_id=18$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cncbd_news_15",
    "name": "中国生物技术发展中心-中心动态",
    "siteName": "中国生物技术发展中心",
    "channelName": "中心动态",
    "adapterKey": "cncbd",
    "adapterDir": "cncbd",
    "baseUrl": "https://www.cncbd.org.cn",
    "country": "CN",
    "url": "https://www.cncbd.org.cn/News/Index/15",
    "category": "新闻动态-中心动态",
    "description": "中国生物技术发展中心动态新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/News/Index/15 · 入库分类标签 3 项（中心动态、生物技术…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/News/Index/15",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "中心动态",
        "生物技术",
        "科技发展"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cncbd\",\n  \"parser\": \"cncbd\",\n  \"difficulty\": 1,\n  \"category\": \"新闻动态-中心动态\",\n  \"description\": \"中国生物技术发展中心动态新闻\",\n  \"listPage\": {\n    \"containerSelector\": \"ul\",\n    \"itemSelector\": \"li\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1,\n      \"urlPattern\": \"/News/Index/channel_id=15$page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h2\",\n    \"metaPattern\": \"/日期[：:](.+?)　来源[：:](.+?)　供稿[：:](.+?)　作者[：:](.+?)　类别[：:](.+?)$/\",\n    \"contentSelector\": \"p\",\n    \"dateFormat\": \"YYYY-MM-DD\",\n    \"attachmentExtensions\": [\n      \".pdf\",\n      \".doc\",\n      \".docx\",\n      \".xls\",\n      \".xlsx\",\n      \".ppt\",\n      \".pptx\",\n      \".zip\",\n      \".rar\"\n    ],\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-links\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmdi_dfdt",
    "name": "中国医疗器械信息网-地方动态",
    "siteName": "中国医疗器械信息网",
    "channelName": "地方动态",
    "adapterKey": "cmdi",
    "adapterDir": "cmdi",
    "baseUrl": "https://www.cmdi.org.cn",
    "country": "CN",
    "url": "https://www.cmdi.org.cn/zx_4/dfdt/",
    "category": "资讯-地方动态",
    "description": "各地医疗器械监管动态",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/zx_4/dfdt/ · 入库分类标签：地方监管、省市动态",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 2,
      "path": "/zx_4/dfdt/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "地方监管",
        "省市动态"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmdi\",\n  \"parser\": \"cmdi\",\n  \"difficulty\": 2,\n  \"category\": \"资讯-地方动态\",\n  \"description\": \"各地医疗器械监管动态\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/t20\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".contitle h2\",\n    \"datePattern\": \"/时间[：:](\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"sourcePattern\": \"/来源[：:]([^\\\\s<]+)/\",\n    \"contentSelector\": \"p\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmdi_hyhz",
    "name": "中国医疗器械信息网-会议会展",
    "siteName": "中国医疗器械信息网",
    "channelName": "会议会展",
    "adapterKey": "cmdi",
    "adapterDir": "cmdi",
    "baseUrl": "https://www.cmdi.org.cn",
    "country": "CN",
    "url": "https://www.cmdi.org.cn/zx_4/hyhz/",
    "category": "资讯-会议会展",
    "description": "行业会议与展会信息",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/zx_4/hyhz/ · 入库分类标签 3 项（会议、展会…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 1",
      "priority": 5,
      "path": "/zx_4/hyhz/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "会议",
        "展会",
        "行业活动"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmdi\",\n  \"parser\": \"cmdi\",\n  \"difficulty\": 2,\n  \"category\": \"资讯-会议会展\",\n  \"description\": \"行业会议与展会信息\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/t20\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".contitle h2\",\n    \"datePattern\": \"/时间[：:](\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"sourcePattern\": \"/来源[：:]([^\\\\s<]+)/\",\n    \"contentSelector\": \"p\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmdi_kpxx",
    "name": "中国医疗器械信息网-科普信息",
    "siteName": "中国医疗器械信息网",
    "channelName": "科普信息",
    "adapterKey": "cmdi",
    "adapterDir": "cmdi",
    "baseUrl": "https://www.cmdi.org.cn",
    "country": "CN",
    "url": "https://www.cmdi.org.cn/zx_4/kpxx/",
    "category": "资讯-科普信息",
    "description": "医疗器械科普知识",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/zx_4/kpxx/ · 入库分类标签 3 项（科普、安全使用…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 1",
      "priority": 4,
      "path": "/zx_4/kpxx/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "科普",
        "安全使用",
        "健康知识"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmdi\",\n  \"parser\": \"cmdi\",\n  \"difficulty\": 2,\n  \"category\": \"资讯-科普信息\",\n  \"description\": \"医疗器械科普知识\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/t20\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".contitle h2\",\n    \"datePattern\": \"/时间[：:](\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"sourcePattern\": \"/来源[：:]([^\\\\s<]+)/\",\n    \"contentSelector\": \"p\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmdi_kyjz",
    "name": "中国医疗器械信息网-科研进展",
    "siteName": "中国医疗器械信息网",
    "channelName": "科研进展",
    "adapterKey": "cmdi",
    "adapterDir": "cmdi",
    "baseUrl": "https://www.cmdi.org.cn",
    "country": "CN",
    "url": "https://www.cmdi.org.cn/zx_4/kyjz/",
    "category": "资讯-科研进展",
    "description": "医疗器械科研成果",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/zx_4/kyjz/ · 入库分类标签 3 项（科研、技术创新…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 3,
      "path": "/zx_4/kyjz/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "科研",
        "技术创新",
        "研发"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmdi\",\n  \"parser\": \"cmdi\",\n  \"difficulty\": 2,\n  \"category\": \"资讯-科研进展\",\n  \"description\": \"医疗器械科研成果\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/t20\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".contitle h2\",\n    \"datePattern\": \"/时间[：:](\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"sourcePattern\": \"/来源[：:]([^\\\\s<]+)/\",\n    \"contentSelector\": \"p\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "cmdi_xyzl",
    "name": "中国医疗器械信息网-行业纵览",
    "siteName": "中国医疗器械信息网",
    "channelName": "行业纵览",
    "adapterKey": "cmdi",
    "adapterDir": "cmdi",
    "baseUrl": "https://www.cmdi.org.cn",
    "country": "CN",
    "url": "https://www.cmdi.org.cn/zx_4/xyzl/",
    "category": "资讯-行业纵览",
    "description": "医疗器械行业综合新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/zx_4/xyzl/ · 入库分类标签 3 项（医疗器械、行业资讯…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/zx_4/xyzl/",
      "maxPages": 10,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "tags": [
        "医疗器械",
        "行业资讯",
        "监管动态"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"cmdi\",\n  \"parser\": \"cmdi\",\n  \"difficulty\": 2,\n  \"category\": \"资讯-行业纵览\",\n  \"description\": \"医疗器械行业综合新闻\",\n  \"listPage\": {\n    \"linkSelector\": \"a[href*=\\\"/t20\\\"][href$=\\\".html\\\"]\",\n    \"datePattern\": \"/(\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 10,\n      \"startPage\": 1\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \".contitle h2\",\n    \"datePattern\": \"/时间[：:](\\\\d{4}-\\\\d{2}-\\\\d{2})/\",\n    \"sourcePattern\": \"/来源[：:]([^\\\\s<]+)/\",\n    \"contentSelector\": \"p\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "ccgp_procurement",
    "name": "中国政府采购网-医疗器械采购公告",
    "siteName": "中国政府采购网",
    "channelName": "医疗器械采购公告",
    "adapterKey": "ccgp",
    "adapterDir": "ccgp",
    "baseUrl": "https://search.ccgp.gov.cn",
    "country": "CN",
    "url": "https://search.ccgp.gov.cn",
    "category": "政府采购-医疗设备",
    "description": "中国政府采购网医疗设备、试剂耗材相关招标公告（约46个关键词，每个最多12条）",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "搜索关键词配置（3 项） · 入库分类标签 4 项（政府采购、医疗设备…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "searchConfig.keywords",
        "group": "search",
        "type": "json",
        "label": "搜索关键词配置",
        "specific": true,
        "description": "搜索关键词配置"
      },
      {
        "key": "pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 2,
      "maxPages": 1,
      "searchConfig": {
        "keywords": {
          "highVolume": [
            "医疗设备",
            "免疫",
            "生化",
            "分子",
            "呼吸机",
            "激光治疗",
            "刀"
          ],
          "mediumVolume": [
            "病理",
            "磁共振成像",
            "化学发光",
            "体外诊断",
            "经颅磁刺激",
            "脑电图",
            "导航系统",
            "计算机断层扫描",
            "射频治疗"
          ],
          "lowVolume": [
            "手术机器人",
            "剪刀",
            "缝线",
            "纱布",
            "透明质酸",
            "标志物",
            "聚焦超声",
            "康复机器人",
            "脑机接口",
            "智能实验室",
            "针头",
            "检验科用试剂耗材",
            "外骨骼",
            "病原检测",
            "手术包",
            "敷贴",
            "神经刺激",
            "高流量氧疗",
            "脑磁图",
            "气道管理",
            "神经监测",
            "经皮神经电刺激",
            "胶原蛋白",
            "微生物药敏",
            "经颅直流电刺激",
            "经颅交流电刺激",
            "脑深部刺激",
            "迷走神经刺激",
            "AI影像",
            "肉毒素",
            "酶联免疫吸附测定",
            "即时检测"
          ]
        }
      },
      "pageSize": 20,
      "tags": [
        "政府采购",
        "医疗设备",
        "招标",
        "中标"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"ccgp\",\n  \"parser\": \"ccgp\",\n  \"difficulty\": 2,\n  \"type\": \"html\",\n  \"category\": \"政府采购-医疗设备\",\n  \"description\": \"中国政府采购网医疗设备、试剂耗材相关招标公告（约46个关键词，每个最多12条）\",\n  \"listPage\": {\n    \"itemSelector\": \".vT_z ul li\",\n    \"linkSelector\": \"a\",\n    \"datePattern\": \"/(\\\\d{4})\\\\.(\\\\d{1,2})\\\\.(\\\\d{1,2})\\\\s+(\\\\d{1,2}):(\\\\d{1,2}):(\\\\d{1,2})/\",\n    \"buyerPattern\": \"/采购人[：:]\\\\s*([^|]+)/\",\n    \"agentPattern\": \"/代理机构[：:]\\\\s*([^|]+)/\",\n    \"pagination\": {\n      \"maxPages\": 1\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h2\",\n    \"contentSelector\": \".vT_detail_content, .detail_content, .vF_detail_main, .content\",\n    \"dateSelector\": \".vT_time, .source\",\n    \"fieldPatterns\": {\n      \"projectId\": \"/项目编号[：:]\\\\s*([^\\\\s<]+)/\",\n      \"projectName\": \"/项目名称[：:]\\\\s*([^\\\\s<]+)/\",\n      \"budgetAmount\": \"/预算金额[：:]\\\\s*([^\\\\s<]+万元[（(]人民币[)）]?)/\",\n      \"maxPrice\": \"/最高限价[（(]如有[)）][：:]\\\\s*([^\\\\s<]+万元)/\",\n      \"bidDeadline\": \"/提交投标文件截止时间[：:]\\\\s*([^\\\\s<]+)/\",\n      \"openTime\": \"/开标时间[：:]\\\\s*([^\\\\s<]+)/\",\n      \"openLocation\": \"/地点[：:]\\\\s*([^\\\\n<]+)/\",\n      \"buyerName\": \"/名\\\\s*称[：:]\\\\s*([^\\\\s<]+)/\",\n      \"buyerAddress\": \"/地\\\\s*址[：:]\\\\s*([^\\\\s<]+)/\",\n      \"buyerContact\": \"/联系方式[：:]\\\\s*([^\\\\s<]+)/\",\n      \"documentUrl\": \"/http[s]?:\\\\/\\\\/[^\\\\s\\\"'<>]+/\",\n      \"documentPrice\": \"/售价[：:]\\\\s*[￥¥]?(\\\\d+\\\\.?\\\\d*)\\\\s*元/\"\n    },\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".footer\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "advamed_events",
    "name": "AdvaMed-Events & Education",
    "siteName": "AdvaMed",
    "channelName": "Events & Education",
    "adapterKey": "advamed",
    "adapterDir": "advamed",
    "baseUrl": "https://www.advamed.org",
    "country": "US",
    "url": "https://www.advamed.org/events/",
    "category": "AdvaMed-活动会议",
    "description": "AdvaMed 活动、会议、研讨会和培训课程",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/events/ · 入库分类标签 5 项（AdvaMed、events…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "dataRange.eventsMinYear",
        "group": "crawl",
        "type": "number",
        "label": "活动最小年份",
        "specific": false,
        "description": "活动最小年份"
      },
      {
        "key": "dataRange.eventsOnlyFuture",
        "group": "crawl",
        "type": "boolean",
        "label": "仅未来活动",
        "specific": false,
        "description": "仅未来活动"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 2,
      "path": "/events/",
      "maxPages": 1,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12,
        "eventsMinYear": 2026,
        "eventsOnlyFuture": true
      },
      "tags": [
        "AdvaMed",
        "events",
        "conference",
        "workshop",
        "webinar"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"advamed\",\n  \"parser\": \"advamed\",\n  \"difficulty\": 1,\n  \"category\": \"AdvaMed-活动会议\",\n  \"description\": \"AdvaMed 活动、会议、研讨会和培训课程\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": false,\n      \"type\": \"facetwp\",\n      \"startPage\": 1,\n      \"perPage\": 10,\n      \"maxPages\": 1\n    },\n    \"linkSelector\": \"a[href*=\\\"/events/\\\"]\",\n    \"titleSelector\": \"a[href*=\\\"/events/\\\"]\"\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, main .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".related-links\",\n        \".sidebar\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    },\n    \"topicsSelector\": \"main a[href*=\\\"/topics/\\\"]\",\n    \"dateSelector\": \"main\",\n    \"registerSelector\": \"a[href*=\\\"cvent.com\\\"], a[href*=\\\"zoom.us\\\"], a:contains(\\\"Register\\\"), a:contains(\\\"RSVP\\\")\"\n  }\n}"
  },
  {
    "sourceId": "advamed_news",
    "name": "AdvaMed-Press Releases",
    "siteName": "AdvaMed",
    "channelName": "Press Releases",
    "adapterKey": "advamed",
    "adapterDir": "advamed",
    "baseUrl": "https://www.advamed.org",
    "country": "US",
    "url": "https://www.advamed.org/industry-updates/news/",
    "category": "AdvaMed-新闻发布",
    "description": "AdvaMed 官方新闻发布和会员新闻",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/industry-updates/news/ · 入库分类标签 4 项（AdvaMed、medtech…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "dataRange.eventsMinYear",
        "group": "crawl",
        "type": "number",
        "label": "活动最小年份",
        "specific": false,
        "description": "活动最小年份"
      },
      {
        "key": "dataRange.eventsOnlyFuture",
        "group": "crawl",
        "type": "boolean",
        "label": "仅未来活动",
        "specific": false,
        "description": "仅未来活动"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "path": "/industry-updates/news/",
      "maxPages": 64,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12,
        "eventsMinYear": 2026,
        "eventsOnlyFuture": true
      },
      "tags": [
        "AdvaMed",
        "medtech",
        "press release",
        "news"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"advamed\",\n  \"parser\": \"advamed\",\n  \"difficulty\": 1,\n  \"category\": \"AdvaMed-新闻发布\",\n  \"description\": \"AdvaMed 官方新闻发布和会员新闻\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"facetwp\",\n      \"startPage\": 1,\n      \"perPage\": 10,\n      \"maxPages\": 64\n    },\n    \"linkSelector\": \"a[href*=\\\"/industry-updates/news/\\\"]\",\n    \"titleSelector\": \"a[href*=\\\"/industry-updates/news/\\\"]\",\n    \"datePattern\": \"/(January|February|March|April|May|June|July|August|September|October|November|December)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/\"\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, main .content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".related-links\",\n        \".sidebar\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    },\n    \"topicsSelector\": \"main a[href*=\\\"/topics/\\\"]\"\n  }\n}"
  },
  {
    "sourceId": "bcgsearch_healthcare",
    "name": "BCG (Search)-BCG Healthcare Search",
    "siteName": "BCG (Search)",
    "channelName": "BCG Healthcare Search",
    "adapterKey": "bcgsearch",
    "adapterDir": "bcg-search",
    "baseUrl": "https://www.bcg.com",
    "country": "Global",
    "url": "https://www.bcg.com/search",
    "category": "BCG-医疗搜索",
    "description": "BCG 医疗健康领域搜索结果（含中文报告）",
    "crawlMode": "portal_keyword",
    "crawlModeLabel": "站内搜索",
    "crawlModeSummary": "在垂直站点用单个关键词搜索（如招标网）",
    "crawlModeDetail": "如千里马招标、BCG 站内搜索。每个栏目通常对应一个搜索词。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "keyword",
      "maxPages"
    ],
    "configSummary": "栏目路径：/search · 入库分类标签 5 项（BCG、healthcare…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "10 3 * * *",
      "priority": 2,
      "path": "/search",
      "maxPages": 5,
      "dataRange": {
        "recentMonths": 0
      },
      "tags": [
        "BCG",
        "healthcare",
        "medtech",
        "biopharma",
        "china"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bcgsearch\",\n  \"parser\": \"bcgsearch\",\n  \"difficulty\": 3,\n  \"category\": \"BCG-医疗搜索\",\n  \"description\": \"BCG 医疗健康领域搜索结果（含中文报告）\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-offset\",\n      \"startOffset\": 0,\n      \"perPage\": 10,\n      \"maxPages\": 5\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".StickyToolbar\",\n        \".share-box\",\n        \".subscribe-form\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "bcg_publications",
    "name": "BCG-Featured Insights",
    "siteName": "BCG",
    "channelName": "Featured Insights",
    "adapterKey": "bcg",
    "adapterDir": "bcg",
    "baseUrl": "https://www.bcg.com",
    "country": "Global",
    "url": "https://www.bcg.com/publications",
    "category": "BCG-洞察报告",
    "description": "BCG 最新研究报告、文章和洞察",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/publications · 内容过滤（1 项） · 入库分类标签 6 项（BCG、consulting…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "contentFilter",
        "group": "search",
        "type": "json",
        "label": "内容过滤",
        "specific": true,
        "description": "内容过滤"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * *",
      "priority": 1,
      "path": "/publications",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 24
      },
      "contentFilter": {
        "excludeTypes": [
          "VIDEO",
          "PODCAST"
        ]
      },
      "tags": [
        "BCG",
        "consulting",
        "strategy",
        "AI",
        "digital",
        "sustainability"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"bcg\",\n  \"parser\": \"bcg\",\n  \"difficulty\": 3,\n  \"category\": \"BCG-洞察报告\",\n  \"description\": \"BCG 最新研究报告、文章和洞察\",\n  \"listPage\": {\n    \"itemSelector\": \".Promo-title a[href*=\\\"/publications/\\\"]\",\n    \"linkSelector\": \"a\",\n    \"titleSelector\": \"a\",\n    \"datePattern\": \"/(January|February|March|April|May|June|July|August|September|October|November|December)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"fragment-api\",\n      \"startPage\": 1,\n      \"perPage\": 8,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"dateSelector\": \"banner\",\n    \"contentSelector\": \"main\",\n    \"authorSelector\": \"a[href*=\\\"/about/people/experts/\\\"]\",\n    \"categorySelector\": \"a[href*=\\\"/capabilities/\\\"], a[href*=\\\"/industries/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".StickyToolbar\",\n        \".share-box\",\n        \".subscribe-form\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "businesswire_medical",
    "name": "Business Wire-医疗健康新闻",
    "siteName": "Business Wire",
    "channelName": "医疗健康新闻",
    "adapterKey": "businesswire",
    "adapterDir": "businesswire",
    "baseUrl": "https://www.businesswire.com",
    "country": "Global",
    "url": "https://www.businesswire.com",
    "category": "新闻资讯",
    "description": "BusinessWire 医疗健康相关新闻 (49个关键词 + Health行业)",
    "crawlMode": "keyword_search",
    "crawlModeLabel": "关键词检索",
    "crawlModeSummary": "在新闻/数据库站点按多个关键词搜索后采集",
    "crawlModeDetail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths",
      "keywords"
    ],
    "configSummary": "搜索关键词 48 项（MRI、PET-CT…） · 行业 ID：1000088 · 行业列表（2 项）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "keywords",
        "group": "search",
        "type": "tags",
        "label": "搜索关键词",
        "specific": true,
        "description": "搜索关键词"
      },
      {
        "key": "industry",
        "group": "search",
        "type": "string",
        "label": "行业 ID",
        "specific": true,
        "description": "行业 ID"
      },
      {
        "key": "industries",
        "group": "search",
        "type": "json",
        "label": "行业列表",
        "specific": true,
        "description": "行业列表"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 0",
      "priority": 5,
      "maxPages": 250,
      "listPage": {
        "pagination": {
          "startPage": 0,
          "pageSize": 10
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "keywords": [
        "MRI",
        "PET-CT",
        "Ultrasound",
        "EEG",
        "MEG",
        "DBS",
        "BCI",
        "TMS",
        "tDCS",
        "Deep Brain Stimulator",
        "FUS",
        "RFA",
        "MWA",
        "Radiofrequency Ablation",
        "Microwave Ablation",
        "Cryotherapy",
        "Cryoablation",
        "Laser",
        "Laser Ablation",
        "high intensity focused ultrasound",
        "Radiotherapy",
        "Brachytherapy",
        "PCR",
        "LAMP",
        "NGS",
        "ELISA",
        "AST",
        "POCT",
        "PFT",
        "SpO2",
        "in Vitro diagnostic",
        "Ventilator",
        "HFOT",
        "High Flow Oxygen Therapy",
        "Oxygen Saturation",
        "Exoskeleton",
        "Rehabilitation Robot",
        "Surgical Robot",
        "Navigation System",
        "Suture",
        "Scalpel",
        "Needle",
        "Disposable Surgical Kit",
        "Scissors",
        "IPL",
        "EBD",
        "Dressing",
        "Gauze"
      ],
      "industry": "1000088",
      "industries": {
        "health": "1000088",
        "medicalDevices": "1000110"
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"businesswire\",\n  \"difficulty\": 3,\n  \"category\": \"新闻资讯\",\n  \"description\": \"BusinessWire 医疗健康相关新闻 (49个关键词 + Health行业)\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 10,\n      \"startPage\": 0,\n      \"maxPages\": 250\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"article, .bw-release-story, .bw-release-body\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".cookie-banner\",\n        \".share-buttons\",\n        \".related-news\",\n        \".bw-release-contact\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "clinicaltrials_device-diagnostics",
    "name": "ClinicalTrials.gov-ClinicalTrials.gov - Device & Diagnostics Studies",
    "siteName": "ClinicalTrials.gov",
    "channelName": "ClinicalTrials.gov - Device & Diagnostics Studies",
    "adapterKey": "clinicaltrials",
    "adapterDir": "clinicaltrials",
    "baseUrl": "https://clinicaltrials.gov",
    "country": "US",
    "url": "https://clinicaltrials.gov",
    "category": "ClinicalTrials-临床试验",
    "description": "ClinicalTrials.gov 医疗器械和诊断类临床试验数据（预估 ~8,000 条）",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "疾病/主题条件 6 项（Neurology、Oncology…） · 干预类型：device、Diagnostics · 研究状态 5 项（RECRUITING、NOT_YET_RECRUITING…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.conditions",
        "group": "search",
        "type": "tags",
        "label": "疾病/主题条件",
        "specific": true,
        "description": "疾病/主题条件"
      },
      {
        "key": "searchConfig.interventionTypes",
        "group": "search",
        "type": "tags",
        "label": "干预类型",
        "specific": true,
        "description": "干预类型"
      },
      {
        "key": "searchConfig.statuses",
        "group": "search",
        "type": "tags",
        "label": "研究状态",
        "specific": true,
        "description": "研究状态"
      },
      {
        "key": "searchConfig.dateFilter",
        "group": "search",
        "type": "json",
        "label": "日期过滤",
        "specific": true,
        "description": "日期过滤"
      },
      {
        "key": "pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "searchConfig": {
        "conditions": [
          "Neurology",
          "Oncology",
          "Aesthetic",
          "Respiratory",
          "Cancer",
          "Infection"
        ],
        "interventionTypes": [
          "device",
          "Diagnostics"
        ],
        "statuses": [
          "RECRUITING",
          "NOT_YET_RECRUITING",
          "ACTIVE_NOT_RECRUITING",
          "COMPLETED",
          "ENROLLING_BY_INVITATION"
        ],
        "dateFilter": {
          "field": "StartDate",
          "minDate": "2020-01-01"
        }
      },
      "pageSize": 100,
      "tags": [
        "ClinicalTrials",
        "clinical trial",
        "device",
        "diagnostic",
        "FDA",
        "NIH"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"clinicaltrials\",\n  \"parser\": \"clinicaltrials\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/studies\",\n  \"category\": \"ClinicalTrials-临床试验\",\n  \"description\": \"ClinicalTrials.gov 医疗器械和诊断类临床试验数据（预估 ~8,000 条）\",\n  \"listPage\": {},\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "conferenceindex_brain_computer_interfaces",
    "name": "Conference Index-Brain-Computer Interfaces Conferences",
    "siteName": "Conference Index",
    "channelName": "Brain-Computer Interfaces Conferences",
    "adapterKey": "conferenceindex",
    "adapterDir": "conferenceindex",
    "baseUrl": "https://conferenceindex.org",
    "country": "Global",
    "url": "https://conferenceindex.org/conferences/brain-computer-interfaces",
    "category": "学术会议",
    "description": "Conference Index - Brain-Computer Interfaces 相关会议列表",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/conferences/brain-compu… · 入库分类标签 4 项（brain-computer interfaces、BCI…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.minYear",
        "group": "crawl",
        "type": "number",
        "label": "最小年份",
        "specific": false,
        "description": "最小年份"
      },
      {
        "key": "dataRange.onlyFuture",
        "group": "crawl",
        "type": "boolean",
        "label": "仅未来事件",
        "specific": false,
        "description": "仅未来事件"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 1",
      "priority": 1,
      "path": "/conferences/brain-computer-interfaces",
      "maxPages": 10,
      "dataRange": {
        "minYear": 2026,
        "onlyFuture": true
      },
      "tags": [
        "brain-computer interfaces",
        "BCI",
        "neuroscience",
        "conference"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"conferenceindex\",\n  \"parser\": \"conferenceindex\",\n  \"difficulty\": 1,\n  \"category\": \"学术会议\",\n  \"description\": \"Conference Index - Brain-Computer Interfaces 相关会议列表\",\n  \"listPage\": {\n    \"containerSelector\": \"main\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"maxPages\": 10,\n      \"pageParamName\": \"page\",\n      \"nextPageSelector\": \"nav a:contains(\\\"Next\\\")\",\n      \"currentPageSelector\": \"nav .active\"\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"main, article, .content, #content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".navigation\",\n        \".sidebar\",\n        \".cookie-banner\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "eudamed_devices-by-keywords",
    "name": "EUDAMED-EUDAMED Devices by Keywords",
    "siteName": "EUDAMED",
    "channelName": "EUDAMED Devices by Keywords",
    "adapterKey": "eudamed",
    "adapterDir": "eudamed",
    "baseUrl": "https://ec.europa.eu/tools/eudamed",
    "country": "EU",
    "url": "https://ec.europa.eu/tools/eudamed",
    "category": "EUDAMED-医疗器械",
    "description": "EUDAMED 按关键词搜索的在市医疗器械数据（42个关键词，预估57,937条）",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "分类编码 496 项（J02010101、J02010102…） · 入库分类标签 5 项（EUDAMED、medical device…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.keywords",
        "group": "search",
        "type": "tags",
        "label": "分类编码",
        "specific": true,
        "description": "分类编码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * *",
      "priority": 1,
      "searchConfig": {
        "keywords": [
          "J02010101",
          "J02010102",
          "J020102",
          "J020180",
          "J020199",
          "J0202",
          "J020201",
          "J020202",
          "J02020201",
          "J02020202",
          "J020203",
          "J020280",
          "J020299",
          "J0203",
          "J020301",
          "J020302",
          "J020380",
          "J020399",
          "J0204",
          "J020401",
          "J020402",
          "J020403",
          "J020480",
          "J020499",
          "J0206",
          "J0207",
          "J020701",
          "J020780",
          "J020782",
          "J020785",
          "J020792",
          "J0280",
          "J0299",
          "W010201",
          "W01020101",
          "W0102010101",
          "W0102010102",
          "W0102010103",
          "W0102010104",
          "W0102010105",
          "W0102010106",
          "W0102010107",
          "W0102010108",
          "W0102010109",
          "W0102010110",
          "W0102010111",
          "W0102010112",
          "W0102010113",
          "W0102010114",
          "W0102010199",
          "W01020103",
          "W0102010301",
          "W0102010302",
          "W0102010303",
          "W0102010304",
          "W0102010305",
          "W0102010306",
          "W0102010307",
          "W0102010308",
          "W0102010309",
          "W0102010399",
          "W010208",
          "W01020801",
          "W0102080101",
          "W0102080102",
          "W0102080103",
          "W0102080104",
          "W0102080105",
          "W0102080106",
          "W0102080107",
          "W0102080108",
          "W0102080109",
          "W0102080199",
          "W01020802",
          "W0102080201",
          "W0102080202",
          "W0102080203",
          "W0102080204",
          "W0102080205",
          "W0102080206",
          "W0102080207",
          "W0102080208",
          "W0102080209",
          "W0102080210",
          "W0102080211",
          "W0102080212",
          "W0102080213",
          "W0102080214",
          "W0102080215",
          "W0102080299",
          "W01020803",
          "W0102080301",
          "W0102080303",
          "W0102080305",
          "W0102080307",
          "W0102080309",
          "W0102080311",
          "W0102080313",
          "W0102080315",
          "W0102080317",
          "W0102080319",
          "W0102080321",
          "W0102080399",
          "W01020804",
          "W0102080401",
          "W0102080402",
          "W0102080499",
          "W01020805",
          "W0102080501",
          "W0102080599",
          "W01020806",
          "W0102080601",
          "W0102080602",
          "W0102080603",
          "W0102080604",
          "W0102080605",
          "W0102080606",
          "W0102080699",
          "W01020807",
          "W0102080701",
          "W0102080702",
          "W0102080703",
          "W0102080704",
          "W0102080799",
          "W01020899",
          "W010214",
          "W01021499",
          "W010216",
          "W01021601",
          "W0102160101",
          "W0102160102",
          "W0102160199",
          "W01021602",
          "W0102160201",
          "W0102160202",
          "W0102160203",
          "W0102160299",
          "W01021603",
          "W0102160301",
          "W0102160302",
          "W0102160303",
          "W0102160304",
          "W0102160399",
          "W01021604",
          "W0102160401",
          "W0102160499",
          "W01021605",
          "W0102160501",
          "W0102160502",
          "W0102160503",
          "W0102160504",
          "W0102160505",
          "W0102160506",
          "W0102160507",
          "W0102160508",
          "W0102160509",
          "W0102160510",
          "W0102160511",
          "W0102160599",
          "W01021606",
          "W0102160601",
          "W0102160699",
          "W01021607",
          "W0102160701",
          "W0102160702",
          "W0102160703",
          "W0102160704",
          "W0102160705",
          "W0102160706",
          "W0102160799",
          "W01021608",
          "W0102160801",
          "W0102160802",
          "W01021609",
          "W0102160901",
          "W0102160902",
          "W0102160903",
          "W0102160999",
          "W01021699",
          "W010217",
          "W01021701",
          "W01021702",
          "W01021799",
          "W0102019013",
          "W0102019014",
          "W0102019015",
          "W0102019016",
          "W0102019017",
          "W0102030101",
          "W0102030102",
          "W0102030103",
          "W0102030104",
          "W0102030105",
          "W0102030106",
          "W0102030107",
          "W0102030108",
          "W0102030109",
          "W0102030110",
          "W0102030111",
          "W0102030112",
          "W0102030113",
          "W0102030114",
          "W0102030115",
          "W0102030116",
          "W0102030117",
          "W0102030118",
          "W0102030119",
          "W0102030120",
          "W0102030121",
          "W0102030122",
          "W0102030123",
          "W0102030124",
          "W0102030125",
          "W0102030126",
          "W0102030127",
          "W0102030199",
          "W0102030201",
          "W0102030202",
          "W0102030299",
          "W0102030301",
          "W0102030302",
          "W0102030399",
          "W0102039001",
          "W0102039002",
          "W0102039003",
          "W0102039004",
          "W0102039005",
          "W0102039006",
          "W0102039007",
          "W0102039008",
          "W0102039009",
          "W0102039010",
          "W0102039011",
          "W0102039013",
          "W0102039014",
          "W0102039015",
          "W0102039017",
          "W0102039018",
          "W0102039019",
          "W0102039099",
          "W01030601",
          "W01030602",
          "W01030603",
          "W01030604",
          "W01030605",
          "W01030606",
          "W01030607",
          "W01030609",
          "W01030699",
          "W0105010107",
          "W0105010108",
          "W0105010109",
          "W0105010110",
          "W0105010111",
          "W0105010112",
          "W0105010113",
          "W0105010114",
          "W0105010115",
          "W0105010116",
          "W0105010117",
          "W0105010118",
          "W0105010199",
          "W0105010201",
          "W0105010202",
          "W0105010203",
          "W0105010299",
          "W0105010301",
          "W0105010302",
          "W0105010303",
          "W0105010304",
          "W0105010305",
          "W0105010399",
          "W0105010401",
          "W0105010402",
          "W0105010403",
          "W0105010499",
          "W0105010701",
          "W0105010702",
          "W0105010703",
          "W0105010704",
          "W0105010799",
          "W0105010801",
          "W0105010802",
          "W0105010803",
          "W0105010899",
          "W0105011101",
          "W0105011102",
          "W0105011103",
          "W0105011104",
          "W0105011105",
          "W0105011199",
          "W0105011707",
          "W0105011708",
          "W0105020101",
          "W0105020102",
          "W0105020103",
          "W0105020104",
          "W0105020105",
          "W0105020199",
          "W0105020201",
          "W0105020202",
          "W0105020203",
          "W0105020204",
          "W0105020205",
          "W0105020206",
          "W0105020207",
          "W0105020208",
          "W0105020209",
          "W0105020210",
          "W0105020211",
          "W0105020212",
          "W0105020213",
          "W0105020214",
          "W0105020215",
          "W0105020216",
          "W0105020217",
          "W0105020218",
          "W0105020299",
          "W0105020301",
          "W0105020302",
          "W0105020303",
          "W0105020304",
          "W0105020305",
          "W0105020306",
          "W0105020307",
          "W0105020308",
          "W0105020309",
          "W0105020399",
          "W0105020401",
          "W0105020406",
          "W0105020501",
          "W0105020503",
          "W0105020504",
          "W0105020505",
          "W0105020506",
          "W0105020507",
          "W0105020599",
          "W0105030101",
          "W0105030102",
          "W0105030103",
          "W0105030104",
          "W0105030105",
          "W0105030106",
          "W0105030107",
          "W0105030108",
          "W0105030199",
          "W0105030201",
          "W0105030202",
          "W0105030203",
          "W0105030204",
          "W0105030205",
          "W0105030299",
          "W0105030301",
          "W0105030302",
          "W0105030303",
          "W0105030399",
          "W0105030401",
          "W0105030402",
          "W0105030403",
          "W0105030404",
          "W0105030405",
          "W0105030499",
          "W0105040501",
          "W0105040502",
          "W0105040504",
          "W0105040505",
          "W0105040506",
          "W0105040509",
          "W0105040511",
          "W0105040512",
          "W0105040513",
          "W0105040514",
          "W0105040515",
          "W0105040516",
          "W0105040517",
          "W0105040518",
          "W0105040520",
          "W0105040521",
          "W0105040522",
          "W0105040523",
          "W0105040524",
          "W0105040525",
          "W0105040526",
          "W0105040528",
          "W0105040529",
          "W0105040530",
          "W0105040531",
          "W0105040532",
          "W0105040599",
          "W0105040601",
          "W0105040602",
          "W0105040604",
          "W0105040605",
          "W0105040606",
          "W0105040609",
          "W0105040611",
          "W0105040612",
          "W0105040613",
          "W0105040614",
          "W0105040615",
          "W0105040616",
          "W0105040617",
          "W0105040618",
          "W0105040620",
          "W0105040621",
          "W0105040622",
          "W0105040623",
          "W0105040624",
          "W0105040625",
          "W0105040626",
          "W0105040627",
          "W0105040628",
          "W0105040629",
          "W0105040630",
          "W0105040699",
          "W0105040701",
          "W0105040702",
          "W0105040703",
          "W0105040704",
          "W0105040799",
          "W0105040801",
          "W0105040802",
          "W0105040803",
          "W0105040804",
          "W0105040899",
          "W0105040901",
          "W0105040902",
          "W0105040903",
          "W0105040904",
          "W0105040999",
          "W0105050209",
          "W0105060301",
          "W0105060302",
          "W0105060303",
          "W0105060399",
          "W0105060401",
          "W0105060402",
          "W0105060403",
          "W0105060404",
          "W0105060405",
          "W0105060499",
          "W0105070201",
          "W0105070202",
          "W0105070203",
          "W0105070301",
          "W0105070302",
          "W0105070303",
          "W0105070304",
          "W0105070399",
          "W0105070501",
          "W0105070502",
          "W0105070503",
          "W0105070504",
          "W0105070505",
          "W0105070506",
          "W0105070507",
          "W0105070599",
          "W0105090101",
          "W0105090102",
          "W0105090103",
          "W0105090104",
          "W0105090105",
          "W0105090201",
          "W0105090202",
          "W0105090299",
          "W0105090301",
          "W0105090302",
          "W0105090303",
          "W0105090399",
          "W0105090401",
          "W0105090499",
          "W0105099001",
          "W0105099002",
          "W0105099003",
          "W0105099004",
          "W0105099006",
          "W0105099007",
          "W0105099008",
          "W0105099099",
          "Z121011",
          "Z12101101",
          "Z12101102",
          "Z12101103",
          "Z12101104",
          "Z12101105",
          "Z12101106",
          "Z12101180",
          "Z12101182",
          "Z12101185",
          "Z12101192",
          "Z12101199",
          "Z12109080",
          "Z12109082",
          "Z12109085",
          "Z12109092",
          "Z12109099"
        ]
      },
      "tags": [
        "EUDAMED",
        "medical device",
        "EU",
        "MDR",
        "CE"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"eudamed\",\n  \"parser\": \"eudamed\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/devices/udiDiData\",\n  \"category\": \"EUDAMED-医疗器械\",\n  \"description\": \"EUDAMED 按关键词搜索的在市医疗器械数据（42个关键词，预估57,937条）\",\n  \"listPage\": {},\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "eurlex_medical-device-ivd",
    "name": "EUR-Lex (欧盟法律数据库)-Medical Device & IVD Regulations",
    "siteName": "EUR-Lex (欧盟法律数据库)",
    "channelName": "Medical Device & IVD Regulations",
    "adapterKey": "eurlex",
    "adapterDir": "eurlex",
    "baseUrl": "https://eur-lex.europa.eu",
    "country": "EU",
    "url": "https://eur-lex.europa.eu",
    "category": "EU-法规-医疗器械",
    "description": "官方推荐查询：只获取法规、指令、决定等正式文件",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "查询语句：(TI ~ medical device OR …",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "query",
        "group": "search",
        "type": "string",
        "label": "查询语句",
        "specific": true,
        "description": "查询语句"
      },
      {
        "key": "pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * 0",
      "query": "(TI ~ medical device OR TI ~ IVD OR TE ~ IVD OR TE ~ medical device) AND DD_YEAR = 2025",
      "pageSize": 100
    },
    "readOnlyPreview": "{\n  \"adapter\": \"eurlex\",\n  \"parser\": \"eurlex\",\n  \"difficulty\": 2,\n  \"type\": \"expert-query\",\n  \"category\": \"EU-法规-医疗器械\",\n  \"description\": \"官方推荐查询：只获取法规、指令、决定等正式文件\",\n  \"listPage\": {},\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "fdadevice_pma",
    "name": "FDA Device-FDA Device PMA",
    "siteName": "FDA Device",
    "channelName": "FDA Device PMA",
    "adapterKey": "fdadevice",
    "adapterDir": "fda-device",
    "baseUrl": "https://api.fda.gov",
    "country": "US",
    "url": "https://api.fda.gov",
    "category": "FDA-医疗器械PMA",
    "description": "FDA PMA（Premarket Approval）按 Product Code 采集；运营可配 searchConfig.keywords",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "分类编码 275 项（BWK、EPG…） · 入库分类标签 4 项（FDA、PMA…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.keywords",
        "group": "search",
        "type": "tags",
        "label": "分类编码",
        "specific": true,
        "description": "分类编码"
      },
      {
        "key": "pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * 1",
      "priority": 2,
      "searchConfig": {
        "keywords": [
          "BWK",
          "EPG",
          "LLE",
          "LPQ",
          "LYI",
          "LYJ",
          "MBX",
          "MFR",
          "MHY",
          "MKD",
          "MNQ",
          "MRU",
          "MUZ",
          "LGW",
          "NHL",
          "OIR",
          "OLM",
          "PFN",
          "PJS",
          "PMP",
          "PSR",
          "QLK",
          "QPY",
          "SDL",
          "SFJ",
          "KOI",
          "BXM",
          "BXN",
          "DSR",
          "LTF",
          "QTT",
          "QNO",
          "KHH",
          "ETP",
          "ETN",
          "QWP",
          "PDQ",
          "NRW",
          "SFN",
          "NTU",
          "GWF",
          "SDX",
          "GZP",
          "GWE",
          "JXK",
          "QJQ",
          "OBP",
          "OKP",
          "GZI",
          "GZA",
          "GZE",
          "GYZ",
          "GZC",
          "GZF",
          "GZB",
          "LHG",
          "QPL",
          "LIH",
          "NUH",
          "OCF",
          "NHI",
          "NYW",
          "GZJ",
          "PCC",
          "PKR",
          "QAK",
          "QAR",
          "QBC",
          "HLX",
          "IPF",
          "NYY",
          "NYZ",
          "NGX",
          "SGT",
          "HII",
          "KSJ",
          "LOL",
          "LOM",
          "LQI",
          "MKT",
          "MZO",
          "MZP",
          "OBF",
          "SBP",
          "SEI",
          "GNR",
          "GNS",
          "GNT",
          "GNW",
          "GNX",
          "GNY",
          "GNZ",
          "GOA",
          "GOB",
          "GOC",
          "GOD",
          "GOX",
          "GOY",
          "GOZ",
          "GQE",
          "GQF",
          "GQG",
          "GQP",
          "GQQ",
          "GQR",
          "GQS",
          "GQT",
          "GRP",
          "LKT",
          "MCE",
          "NHY",
          "NHZ",
          "NIA",
          "NXD",
          "OCC",
          "OEM",
          "OEP",
          "OMG",
          "OMS",
          "OOU",
          "OQW",
          "OTG",
          "OZE",
          "OZX",
          "OZY",
          "OZZ",
          "PSZ",
          "PZF",
          "QBH",
          "QDP",
          "QDS",
          "QJR",
          "QKO",
          "QKP",
          "QLT",
          "QLW",
          "QMN",
          "QOA",
          "QOF",
          "QQX",
          "QVF",
          "QVP",
          "QWB",
          "QWR",
          "QYT",
          "GRT",
          "LQF",
          "MWA",
          "NCD",
          "NDZ",
          "NJO",
          "OJN",
          "OJO",
          "PEU",
          "MTL",
          "MTN",
          "MVW",
          "MVX",
          "MVY",
          "MVZ",
          "MWB",
          "MYR",
          "MZF",
          "NHS",
          "QIC",
          "QSS",
          "QST",
          "QSU",
          "QSV",
          "QUM",
          "SBZ",
          "LIQ",
          "OUC",
          "PCH",
          "PCI",
          "PIQ",
          "LYR",
          "OWF",
          "GPT",
          "GPW",
          "GQL",
          "GQM",
          "GQN",
          "GQO",
          "GTH",
          "GTX",
          "GTY",
          "GTZ",
          "JSX",
          "LGA",
          "LGC",
          "LHK",
          "LIC",
          "LIR",
          "LJC",
          "LJP",
          "LKC",
          "LKH",
          "LKI",
          "LSK",
          "LTS",
          "MAQ",
          "MCD",
          "MGM",
          "MJM",
          "MKZ",
          "MXJ",
          "MYF",
          "MZE",
          "NJR",
          "OMI",
          "OPM",
          "OQO",
          "OUY",
          "OYB",
          "OYZ",
          "PAB",
          "PGH",
          "PGI",
          "PGX",
          "PQA",
          "PUQ",
          "QDZ",
          "QEP",
          "QLX",
          "QMI",
          "QYA",
          "SEA",
          "GOI",
          "GQY",
          "GQZ",
          "GRA",
          "GRB",
          "GRC",
          "GRD",
          "GSM",
          "GSO",
          "GSQ",
          "LJY",
          "MYZ",
          "NHT",
          "NWY",
          "NXX",
          "NZS",
          "OAH",
          "OAI",
          "OAX",
          "OEH",
          "OIH",
          "OMN",
          "OPL",
          "OSU",
          "OUZ",
          "OVF",
          "OZB",
          "PAM",
          "PEN",
          "PEO",
          "PII",
          "PLO",
          "POA",
          "POG",
          "PRA",
          "PVQ",
          "PYN",
          "QAA",
          "QCU",
          "QHO",
          "QSN",
          "QTP",
          "QTQ",
          "QVR",
          "SDM",
          "SDN",
          "SDP"
        ]
      },
      "pageSize": 1000,
      "tags": [
        "FDA",
        "PMA",
        "premarket approval",
        "medical device"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"fdadevice\",\n  \"parser\": \"fdadevice\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/device/pma.json\",\n  \"category\": \"FDA-医疗器械PMA\",\n  \"description\": \"FDA PMA（Premarket Approval）按 Product Code 采集；运营可配 searchConfig.keywords\",\n  \"listPage\": {},\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "fdadevice_registrationlisting",
    "name": "FDA Device-FDA Device Registration & Listing",
    "siteName": "FDA Device",
    "channelName": "FDA Device Registration & Listing",
    "adapterKey": "fdadevice",
    "adapterDir": "fda-device",
    "baseUrl": "https://api.fda.gov",
    "country": "US",
    "url": "https://api.fda.gov",
    "category": "FDA-医疗器械注册",
    "description": "FDA 设备注册与列表数据（预估 ~21,000 条）",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "分类编码 275 项（BWK、EPG…） · 入库分类标签 5 项（FDA、medical device…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.keywords",
        "group": "search",
        "type": "tags",
        "label": "分类编码",
        "specific": true,
        "description": "分类编码"
      },
      {
        "key": "pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 1",
      "priority": 1,
      "searchConfig": {
        "keywords": [
          "BWK",
          "EPG",
          "LLE",
          "LPQ",
          "LYI",
          "LYJ",
          "MBX",
          "MFR",
          "MHY",
          "MKD",
          "MNQ",
          "MRU",
          "MUZ",
          "LGW",
          "NHL",
          "OIR",
          "OLM",
          "PFN",
          "PJS",
          "PMP",
          "PSR",
          "QLK",
          "QPY",
          "SDL",
          "SFJ",
          "KOI",
          "BXM",
          "BXN",
          "DSR",
          "LTF",
          "QTT",
          "QNO",
          "KHH",
          "ETP",
          "ETN",
          "QWP",
          "PDQ",
          "NRW",
          "SFN",
          "NTU",
          "GWF",
          "SDX",
          "GZP",
          "GWE",
          "JXK",
          "QJQ",
          "OBP",
          "OKP",
          "GZI",
          "GZA",
          "GZE",
          "GYZ",
          "GZC",
          "GZF",
          "GZB",
          "LHG",
          "QPL",
          "LIH",
          "NUH",
          "OCF",
          "NHI",
          "NYW",
          "GZJ",
          "PCC",
          "PKR",
          "QAK",
          "QAR",
          "QBC",
          "HLX",
          "IPF",
          "NYY",
          "NYZ",
          "NGX",
          "SGT",
          "HII",
          "KSJ",
          "LOL",
          "LOM",
          "LQI",
          "MKT",
          "MZO",
          "MZP",
          "OBF",
          "SBP",
          "SEI",
          "GNR",
          "GNS",
          "GNT",
          "GNW",
          "GNX",
          "GNY",
          "GNZ",
          "GOA",
          "GOB",
          "GOC",
          "GOD",
          "GOX",
          "GOY",
          "GOZ",
          "GQE",
          "GQF",
          "GQG",
          "GQP",
          "GQQ",
          "GQR",
          "GQS",
          "GQT",
          "GRP",
          "LKT",
          "MCE",
          "NHY",
          "NHZ",
          "NIA",
          "NXD",
          "OCC",
          "OEM",
          "OEP",
          "OMG",
          "OMS",
          "OOU",
          "OQW",
          "OTG",
          "OZE",
          "OZX",
          "OZY",
          "OZZ",
          "PSZ",
          "PZF",
          "QBH",
          "QDP",
          "QDS",
          "QJR",
          "QKO",
          "QKP",
          "QLT",
          "QLW",
          "QMN",
          "QOA",
          "QOF",
          "QQX",
          "QVF",
          "QVP",
          "QWB",
          "QWR",
          "QYT",
          "GRT",
          "LQF",
          "MWA",
          "NCD",
          "NDZ",
          "NJO",
          "OJN",
          "OJO",
          "PEU",
          "MTL",
          "MTN",
          "MVW",
          "MVX",
          "MVY",
          "MVZ",
          "MWB",
          "MYR",
          "MZF",
          "NHS",
          "QIC",
          "QSS",
          "QST",
          "QSU",
          "QSV",
          "QUM",
          "SBZ",
          "LIQ",
          "OUC",
          "PCH",
          "PCI",
          "PIQ",
          "LYR",
          "OWF",
          "GPT",
          "GPW",
          "GQL",
          "GQM",
          "GQN",
          "GQO",
          "GTH",
          "GTX",
          "GTY",
          "GTZ",
          "JSX",
          "LGA",
          "LGC",
          "LHK",
          "LIC",
          "LIR",
          "LJC",
          "LJP",
          "LKC",
          "LKH",
          "LKI",
          "LSK",
          "LTS",
          "MAQ",
          "MCD",
          "MGM",
          "MJM",
          "MKZ",
          "MXJ",
          "MYF",
          "MZE",
          "NJR",
          "OMI",
          "OPM",
          "OQO",
          "OUY",
          "OYB",
          "OYZ",
          "PAB",
          "PGH",
          "PGI",
          "PGX",
          "PQA",
          "PUQ",
          "QDZ",
          "QEP",
          "QLX",
          "QMI",
          "QYA",
          "SEA",
          "GOI",
          "GQY",
          "GQZ",
          "GRA",
          "GRB",
          "GRC",
          "GRD",
          "GSM",
          "GSO",
          "GSQ",
          "LJY",
          "MYZ",
          "NHT",
          "NWY",
          "NXX",
          "NZS",
          "OAH",
          "OAI",
          "OAX",
          "OEH",
          "OIH",
          "OMN",
          "OPL",
          "OSU",
          "OUZ",
          "OVF",
          "OZB",
          "PAM",
          "PEN",
          "PEO",
          "PII",
          "PLO",
          "POA",
          "POG",
          "PRA",
          "PVQ",
          "PYN",
          "QAA",
          "QCU",
          "QHO",
          "QSN",
          "QTP",
          "QTQ",
          "QVR",
          "SDM",
          "SDN",
          "SDP"
        ]
      },
      "pageSize": 1000,
      "tags": [
        "FDA",
        "medical device",
        "registration",
        "listing",
        "510k"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"fdadevice\",\n  \"parser\": \"fdadevice\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/device/registrationlisting.json\",\n  \"category\": \"FDA-医疗器械注册\",\n  \"description\": \"FDA 设备注册与列表数据（预估 ~21,000 条）\",\n  \"listPage\": {},\n  \"detailPage\": {}\n}"
  },
  {
    "sourceId": "fda_voices",
    "name": "FDA-FDA Voices",
    "siteName": "FDA",
    "channelName": "FDA Voices",
    "adapterKey": "fda",
    "adapterDir": "fda",
    "baseUrl": "https://www.fda.gov",
    "country": "US",
    "url": "https://www.fda.gov/news-events/fda-newsroom/fda-voices",
    "category": "FDA-专家观点",
    "description": "FDA 领导层和专家对公共卫生工作的见解",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news-events/fda-newsroo… · 入库分类标签 5 项（FDA、voices…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 3,
      "path": "/news-events/fda-newsroom/fda-voices",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "FDA",
        "voices",
        "insights",
        "experts",
        "leadership"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"fda\",\n  \"parser\": \"fda\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/datatables-json/fda-voices-json\",\n  \"category\": \"FDA-专家观点\",\n  \"description\": \"FDA 领导层和专家对公共卫生工作的见解\",\n  \"listPage\": {\n    \"containerSelector\": \"main\",\n    \"itemSelector\": \"a\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 0\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h1\",\n    \"eventTypeSelector\": \".lcds-page-title__pretitle, main header .prefix\",\n    \"timeSelector\": \".field--name-field-start-date-time, .event-date-time\",\n    \"contentSelector\": \"main[role=\\\"main\\\"] article, main article, .node__content\",\n    \"materialsTableSelector\": \"table, .file-listing\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header.site-header\",\n        \"footer\",\n        \"nav\",\n        \".feedback-form\",\n        \".lcds-page-header__social\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "fda_press",
    "name": "FDA-Press Announcements",
    "siteName": "FDA",
    "channelName": "Press Announcements",
    "adapterKey": "fda",
    "adapterDir": "fda",
    "baseUrl": "https://www.fda.gov",
    "country": "US",
    "url": "https://www.fda.gov/news-events/fda-newsroom/press-announcements",
    "category": "FDA-新闻发布",
    "description": "FDA 官方新闻发布和公告",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news-events/fda-newsroo… · 入库分类标签 5 项（FDA、press…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 4,
      "path": "/news-events/fda-newsroom/press-announcements",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "FDA",
        "press",
        "announcements",
        "news",
        "releases"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"fda\",\n  \"parser\": \"fda\",\n  \"difficulty\": 3,\n  \"type\": \"html\",\n  \"category\": \"FDA-新闻发布\",\n  \"description\": \"FDA 官方新闻发布和公告\",\n  \"listPage\": {\n    \"containerSelector\": \"main\",\n    \"itemSelector\": \"a\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 0,\n      \"urlPattern\": \"/news-events/fda-newsroom/press-announcements?page={page}\"\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h1\",\n    \"eventTypeSelector\": \".lcds-page-title__pretitle, main header .prefix\",\n    \"timeSelector\": \".field--name-field-start-date-time, .event-date-time\",\n    \"contentSelector\": \"main[role=\\\"main\\\"] article, main article, .node__content\",\n    \"materialsTableSelector\": \"table, .file-listing\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header.site-header\",\n        \"footer\",\n        \"nav\",\n        \".feedback-form\",\n        \".lcds-page-header__social\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "fda_upcoming",
    "name": "FDA-Upcoming Events",
    "siteName": "FDA",
    "channelName": "Upcoming Events",
    "adapterKey": "fda",
    "adapterDir": "fda",
    "baseUrl": "https://www.fda.gov",
    "country": "US",
    "url": "https://www.fda.gov/news-events/fda-meetings-conferences-and-workshops",
    "category": "FDA-会议-即将举行",
    "description": "FDA 即将举行的会议、研讨会和工作坊",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/news-events/fda-meeting… · 入库分类标签 5 项（FDA、meetings…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/news-events/fda-meetings-conferences-and-workshops",
      "maxPages": 5,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "tags": [
        "FDA",
        "meetings",
        "conferences",
        "workshops",
        "upcoming"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"fda\",\n  \"parser\": \"fda\",\n  \"difficulty\": 1,\n  \"type\": \"json\",\n  \"jsonEndpoint\": \"/datatables-json/events-meetings.json\",\n  \"category\": \"FDA-会议-即将举行\",\n  \"description\": \"FDA 即将举行的会议、研讨会和工作坊\",\n  \"listPage\": {\n    \"containerSelector\": \"main\",\n    \"itemSelector\": \"a\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url\",\n      \"maxPages\": 5,\n      \"startPage\": 0\n    }\n  },\n  \"detailPage\": {\n    \"titleSelector\": \"h1\",\n    \"eventTypeSelector\": \".lcds-page-title__pretitle, main header .prefix\",\n    \"timeSelector\": \".field--name-field-start-date-time, .event-date-time\",\n    \"contentSelector\": \"main[role=\\\"main\\\"] article, main article, .node__content\",\n    \"materialsTableSelector\": \"table, .file-listing\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \"header.site-header\",\n        \"footer\",\n        \"nav\",\n        \".feedback-form\",\n        \".lcds-page-header__social\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "globenewswire_medical",
    "name": "GlobeNewswire-医疗健康新闻",
    "siteName": "GlobeNewswire",
    "channelName": "医疗健康新闻",
    "adapterKey": "globenewswire",
    "adapterDir": "globenewswire",
    "baseUrl": "https://www.globenewswire.com",
    "country": "Global",
    "url": "https://www.globenewswire.com",
    "category": "新闻资讯",
    "description": "GlobeNewswire 医疗健康相关新闻 (Biotech/Pharma/Medical Device)",
    "crawlMode": "keyword_search",
    "crawlModeLabel": "关键词检索",
    "crawlModeSummary": "在新闻/数据库站点按多个关键词搜索后采集",
    "crawlModeDetail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths",
      "keywords"
    ],
    "configSummary": "行业列表 5 项（Biotechnology、Health Care…） · 内容过滤词 34 个",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "industries",
        "group": "search",
        "type": "tags",
        "label": "行业列表",
        "specific": true,
        "description": "行业列表"
      },
      {
        "key": "contentFilter",
        "group": "search",
        "type": "json",
        "label": "内容过滤",
        "specific": true,
        "description": "内容过滤"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * 0",
      "priority": 5,
      "maxPages": 1000,
      "listPage": {
        "pagination": {
          "pageSize": 50
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "industries": [
        "Biotechnology",
        "Health Care",
        "Health Care Equipment & Services",
        "Medical Equipment",
        "Pharmaceuticals & Biotechnology"
      ],
      "contentFilter": {
        "enabled": false,
        "keywords": [
          "Parkinson",
          "Alzheimer",
          "Epilepsy",
          "DBS",
          "BCI",
          "EEG",
          "MEG",
          "Oncology",
          "Cancer",
          "Tumor",
          "Chemotherapy",
          "Immunotherapy",
          "Infection",
          "COVID",
          "HIV",
          "TB",
          "Sepsis",
          "PCR",
          "Respiratory",
          "COPD",
          "Asthma",
          "Ventilator",
          "Aesthetic",
          "Dermatology",
          "Laser",
          "Botulinum",
          "Diagnostics",
          "IVD",
          "POCT",
          "NGS",
          "ELISA",
          "Medical Device",
          "Surgical",
          "Implant"
        ],
        "matchMode": "any",
        "matchFields": [
          "title",
          "contentText"
        ]
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"globenewswire\",\n  \"difficulty\": 3,\n  \"category\": \"新闻资讯\",\n  \"description\": \"GlobeNewswire 医疗健康相关新闻 (Biotech/Pharma/Medical Device)\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 50,\n      \"maxPages\": 1000\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"article, .main-body-container, .article-body\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".cookie-banner\",\n        \".share-buttons\",\n        \".related-news\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "idataresearch_cardio",
    "name": "iData Research-Cardio Future",
    "siteName": "iData Research",
    "channelName": "Cardio Future",
    "adapterKey": "idataresearch",
    "adapterDir": "idataresearch",
    "baseUrl": "https://idataresearch.com",
    "country": "GLOBAL",
    "url": "https://idataresearch.com/cardiofuture/",
    "category": "心脏病学",
    "description": "",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/cardiofuture/",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "path": "/cardiofuture/",
      "maxPages": 1,
      "dataRange": {
        "recentMonths": 12
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"idataresearch\",\n  \"difficulty\": 1,\n  \"category\": \"心脏病学\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href*=\\\"idataresearch.com/\\\"]:has(h5), h5 a\",\n    \"titleSelector\": \"h5\",\n    \"pagination\": {\n      \"enabled\": false,\n      \"maxPages\": 1\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"metadataSelector\": \"ul.arcle-icon\",\n    \"dateSelector\": \"ul.arcle-icon li:has(.fa-clock-o)\",\n    \"authorSelector\": \"ul.arcle-icon li:has(.fa-user)\",\n    \"categorySelector\": \"ul.arcle-icon li:has(.fa-file-text-o) a\",\n    \"contentSelector\": \"main article, main .entry-content, main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-posts\",\n        \".newsletter-box\",\n        \"header\",\n        \"footer\",\n        \"nav\",\n        \".sidebar\",\n        \".comment-section\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "idataresearch_dental",
    "name": "iData Research-Dental Future",
    "siteName": "iData Research",
    "channelName": "Dental Future",
    "adapterKey": "idataresearch",
    "adapterDir": "idataresearch",
    "baseUrl": "https://idataresearch.com",
    "country": "GLOBAL",
    "url": "https://idataresearch.com/dentalfuture/",
    "category": "口腔医学",
    "description": "",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/dentalfuture/",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "path": "/dentalfuture/",
      "maxPages": 1,
      "dataRange": {
        "recentMonths": 12
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"idataresearch\",\n  \"difficulty\": 1,\n  \"category\": \"口腔医学\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href*=\\\"idataresearch.com/\\\"]:has(h5), h5 a\",\n    \"titleSelector\": \"h5\",\n    \"pagination\": {\n      \"enabled\": false,\n      \"maxPages\": 1\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"metadataSelector\": \"ul.arcle-icon\",\n    \"dateSelector\": \"ul.arcle-icon li:has(.fa-clock-o)\",\n    \"authorSelector\": \"ul.arcle-icon li:has(.fa-user)\",\n    \"categorySelector\": \"ul.arcle-icon li:has(.fa-file-text-o) a\",\n    \"contentSelector\": \"main article, main .entry-content, main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-posts\",\n        \".newsletter-box\",\n        \"header\",\n        \"footer\",\n        \"nav\",\n        \".sidebar\",\n        \".comment-section\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "idataresearch_medtech",
    "name": "iData Research-MedTech Future",
    "siteName": "iData Research",
    "channelName": "MedTech Future",
    "adapterKey": "idataresearch",
    "adapterDir": "idataresearch",
    "baseUrl": "https://idataresearch.com",
    "country": "GLOBAL",
    "url": "https://idataresearch.com/medtechfuture/",
    "category": "医疗技术",
    "description": "",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/medtechfuture/",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "path": "/medtechfuture/",
      "maxPages": 1,
      "dataRange": {
        "recentMonths": 12
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"idataresearch\",\n  \"difficulty\": 1,\n  \"category\": \"医疗技术\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href*=\\\"idataresearch.com/\\\"]:has(h5), h5 a\",\n    \"titleSelector\": \"h5\",\n    \"pagination\": {\n      \"enabled\": false,\n      \"maxPages\": 1\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"metadataSelector\": \"ul.arcle-icon\",\n    \"dateSelector\": \"ul.arcle-icon li:has(.fa-clock-o)\",\n    \"authorSelector\": \"ul.arcle-icon li:has(.fa-user)\",\n    \"categorySelector\": \"ul.arcle-icon li:has(.fa-file-text-o) a\",\n    \"contentSelector\": \"main article, main .entry-content, main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-posts\",\n        \".newsletter-box\",\n        \"header\",\n        \"footer\",\n        \"nav\",\n        \".sidebar\",\n        \".comment-section\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "idataresearch_ortho",
    "name": "iData Research-Ortho Future",
    "siteName": "iData Research",
    "channelName": "Ortho Future",
    "adapterKey": "idataresearch",
    "adapterDir": "idataresearch",
    "baseUrl": "https://idataresearch.com",
    "country": "GLOBAL",
    "url": "https://idataresearch.com/orthofuture/",
    "category": "骨科",
    "description": "",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/orthofuture/",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "path": "/orthofuture/",
      "maxPages": 1,
      "dataRange": {
        "recentMonths": 12
      }
    },
    "readOnlyPreview": "{\n  \"adapter\": \"idataresearch\",\n  \"difficulty\": 1,\n  \"category\": \"骨科\",\n  \"listPage\": {\n    \"itemSelector\": \"a[href*=\\\"idataresearch.com/\\\"]:has(h5), h5 a\",\n    \"titleSelector\": \"h5\",\n    \"pagination\": {\n      \"enabled\": false,\n      \"maxPages\": 1\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"metadataSelector\": \"ul.arcle-icon\",\n    \"dateSelector\": \"ul.arcle-icon li:has(.fa-clock-o)\",\n    \"authorSelector\": \"ul.arcle-icon li:has(.fa-user)\",\n    \"categorySelector\": \"ul.arcle-icon li:has(.fa-file-text-o) a\",\n    \"contentSelector\": \"main article, main .entry-content, main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \".share-box\",\n        \".related-posts\",\n        \".newsletter-box\",\n        \"header\",\n        \"footer\",\n        \"nav\",\n        \".sidebar\",\n        \".comment-section\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "lek_insights",
    "name": "L.E.K. Consulting-L.E.K. Insights",
    "siteName": "L.E.K. Consulting",
    "channelName": "L.E.K. Insights",
    "adapterKey": "lek",
    "adapterDir": "lek",
    "baseUrl": "https://www.lek.com",
    "country": "Global",
    "url": "https://www.lek.com/insights",
    "category": "LEK-洞察报告",
    "description": "L.E.K. 医疗健康领域的咨询洞察、研究报告和行业分析",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/insights · 内容过滤（1 项） · 入库分类标签 6 项（LEK、consulting…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "contentFilter",
        "group": "search",
        "type": "json",
        "label": "内容过滤",
        "specific": true,
        "description": "内容过滤"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * *",
      "priority": 1,
      "path": "/insights",
      "maxPages": 35,
      "listPage": {
        "pagination": {
          "startPage": 0
        }
      },
      "dataRange": {
        "recentMonths": 24
      },
      "contentFilter": {
        "excludeTypes": [
          "PUBLISHED ARTICLES"
        ]
      },
      "tags": [
        "LEK",
        "consulting",
        "healthcare",
        "medtech",
        "pharma",
        "life sciences"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"lek\",\n  \"parser\": \"lek\",\n  \"difficulty\": 1,\n  \"category\": \"LEK-洞察报告\",\n  \"description\": \"L.E.K. 医疗健康领域的咨询洞察、研究报告和行业分析\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-page\",\n      \"startPage\": 0,\n      \"perPage\": 6,\n      \"maxPages\": 35\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \"form\",\n        \".block-lek-social-sharing\",\n        \".block-social-media-links\",\n        \".field--name-field-tags\",\n        \".back-to-top\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mckinsey_mckinsey-explainers",
    "name": "McKinsey & Company-McKinsey Explainers",
    "siteName": "McKinsey & Company",
    "channelName": "McKinsey Explainers",
    "adapterKey": "mckinsey",
    "adapterDir": "mckinsey",
    "baseUrl": "https://www.mckinsey.com",
    "country": "Global",
    "url": "https://www.mckinsey.com/featured-insights/mckinsey-explainers",
    "category": "McKinsey-解读文章",
    "description": "McKinsey 深度解读文章，直接回答复杂问题",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/featured-insights/mckin… · 入库分类标签 5 项（McKinsey、explainers…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 1",
      "priority": 2,
      "path": "/featured-insights/mckinsey-explainers",
      "maxPages": 9,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "McKinsey",
        "explainers",
        "AI",
        "digital",
        "sustainability"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mckinsey\",\n  \"parser\": \"mckinsey\",\n  \"difficulty\": 1,\n  \"category\": \"McKinsey-解读文章\",\n  \"description\": \"McKinsey 深度解读文章，直接回答复杂问题\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"api-page\",\n      \"startPage\": 1,\n      \"maxPages\": 9\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \"form\",\n        \"[class*=\\\"newsletter\\\"]\",\n        \"[class*=\\\"subscribe\\\"]\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mckinsey_week-in-charts",
    "name": "McKinsey & Company-The Week in Charts",
    "siteName": "McKinsey & Company",
    "channelName": "The Week in Charts",
    "adapterKey": "mckinsey",
    "adapterDir": "mckinsey",
    "baseUrl": "https://www.mckinsey.com",
    "country": "Global",
    "url": "https://www.mckinsey.com/featured-insights/week-in-charts",
    "category": "McKinsey-图表洞察",
    "description": "McKinsey 每周数据驱动的图表洞察",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/featured-insights/week-… · 入库分类标签 6 项（McKinsey、charts…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * *",
      "priority": 1,
      "path": "/featured-insights/week-in-charts",
      "maxPages": 9,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "McKinsey",
        "charts",
        "insights",
        "data",
        "AI",
        "strategy"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mckinsey\",\n  \"parser\": \"mckinsey\",\n  \"difficulty\": 1,\n  \"category\": \"McKinsey-图表洞察\",\n  \"description\": \"McKinsey 每周数据驱动的图表洞察\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"api-page\",\n      \"startPage\": 1,\n      \"maxPages\": 9\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \"form\",\n        \"[class*=\\\"newsletter\\\"]\",\n        \"[class*=\\\"subscribe\\\"]\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_business",
    "name": "MDDI Online-Business",
    "siteName": "MDDI Online",
    "channelName": "Business",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/business",
    "category": "MDDI-商业",
    "description": "M&A、投融资、战略、市场动态",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/business · 入库分类标签 6 项（business、M&A…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 6,
      "path": "/business",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "business",
        "M&A",
        "investment",
        "strategy",
        "finance",
        "startups"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-商业\",\n  \"description\": \"M&A、投融资、战略、市场动态\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_digital-health",
    "name": "MDDI Online-Digital Health",
    "siteName": "MDDI Online",
    "channelName": "Digital Health",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/digital-health",
    "category": "MDDI-数字健康",
    "description": "AI、软件、远程医疗、数字化转型",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/digital-health · 入库分类标签 6 项（digital health、AI…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 5,
      "path": "/digital-health",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "digital health",
        "AI",
        "telemedicine",
        "software",
        "SaMD",
        "wearables"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-数字健康\",\n  \"description\": \"AI、软件、远程医疗、数字化转型\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_manufacturing",
    "name": "MDDI Online-Manufacturing",
    "siteName": "MDDI Online",
    "channelName": "Manufacturing",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/manufacturing",
    "category": "MDDI-制造",
    "description": "生产制造、供应链、质量控制",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/manufacturing · 入库分类标签 4 项（manufacturing、production…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 3,
      "path": "/manufacturing",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "manufacturing",
        "production",
        "supply chain",
        "quality control"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-制造\",\n  \"description\": \"生产制造、供应链、质量控制\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_medical-device-markets",
    "name": "MDDI Online-Medical Device Markets",
    "siteName": "MDDI Online",
    "channelName": "Medical Device Markets",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/medical-device-markets",
    "category": "MDDI-医疗器械市场",
    "description": "医疗器械市场分析、行业趋势、细分领域报道",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/medical-device-markets · 入库分类标签 6 项（medical device、market…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 1,
      "path": "/medical-device-markets",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "medical device",
        "market",
        "cardiovascular",
        "diabetes",
        "orthopedic",
        "robotics"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-医疗器械市场\",\n  \"description\": \"医疗器械市场分析、行业趋势、细分领域报道\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_product-development",
    "name": "MDDI Online-Product Development",
    "siteName": "MDDI Online",
    "channelName": "Product Development",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/product-development",
    "category": "MDDI-产品开发",
    "description": "产品研发、设计、原型开发",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/product-development · 入库分类标签 5 项（product development、design…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 2,
      "path": "/product-development",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "product development",
        "design",
        "R&D",
        "prototype",
        "engineering"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-产品开发\",\n  \"description\": \"产品研发、设计、原型开发\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "mddionline_regulatory-quality",
    "name": "MDDI Online-Regulatory & Quality",
    "siteName": "MDDI Online",
    "channelName": "Regulatory & Quality",
    "adapterKey": "mddionline",
    "adapterDir": "mddionline",
    "baseUrl": "https://www.mddionline.com",
    "country": "US",
    "url": "https://www.mddionline.com/regulatory-quality",
    "category": "MDDI-法规与质量",
    "description": "FDA审批、合规、质量管理",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/regulatory-quality · 入库分类标签 7 项（FDA、regulatory…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * *",
      "priority": 4,
      "path": "/regulatory-quality",
      "maxPages": 50,
      "listPage": {
        "pagination": {
          "startPage": 1
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "tags": [
        "FDA",
        "regulatory",
        "compliance",
        "quality",
        "510k",
        "PMA",
        "CE mark"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"mddionline\",\n  \"parser\": \"mddionline\",\n  \"difficulty\": 2,\n  \"category\": \"MDDI-法规与质量\",\n  \"description\": \"FDA审批、合规、质量管理\",\n  \"listPage\": {\n    \"itemSelector\": \".ContentPreview.ListContent-ContentItem\",\n    \"linkSelector\": \"a[href*=\\\"/\\\"]\",\n    \"titleSelector\": \"h2 a, h3 a, a.title\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"]\",\n    \"datePattern\": \"/(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\\\s+\\\\d{1,2},\\\\s+\\\\d{4}/i\",\n    \"pagination\": {\n      \"enabled\": true,\n      \"type\": \"url-param\",\n      \"paramName\": \"page\",\n      \"startPage\": 1,\n      \"perPage\": 30,\n      \"maxPages\": 50\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"titleSelector\": \"h1\",\n    \"contentSelector\": \"main article, .article-content, [class*=\\\"ArticleBody\\\"]\",\n    \"dateSelector\": \"time, [class*=\\\"date\\\"], [class*=\\\"Date\\\"]\",\n    \"authorSelector\": \"a[href*=\\\"/author/\\\"]\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".share-box\",\n        \".subscribe-form\",\n        \".newsletter\",\n        \".advertisement\",\n        \"[class*=\\\"Ad\\\"]\",\n        \"form\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "nature_nrn_conf_conferences",
    "name": "Nature Reviews Neuroscience Conferences-Neuroscience Conferences",
    "siteName": "Nature Reviews Neuroscience Conferences",
    "channelName": "Neuroscience Conferences",
    "adapterKey": "nature-conferences",
    "adapterDir": "nature-conferences",
    "baseUrl": "https://www.nature.com",
    "country": "Global",
    "url": "https://www.nature.com/nrn/conferences",
    "category": "学术会议",
    "description": "Nature Reviews Neuroscience 推荐的神经科学学术会议列表",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/nrn/conferences · 领域关键词（4 项） · 入库分类标签 4 项（神经科学、学术会议…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "focusAreaKeywords",
        "group": "search",
        "type": "json",
        "label": "领域关键词",
        "specific": true,
        "description": "领域关键词"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 1",
      "priority": 1,
      "path": "/nrn/conferences",
      "focusAreaKeywords": {
        "neurodegeneration": [
          "alzheimer",
          "dementia",
          "parkinson",
          "neurodegeneration",
          "neurodegenerative",
          "huntington",
          "als",
          "frontotemporal"
        ],
        "neurology": [
          "sleep",
          "brain",
          "neuron",
          "neural",
          "cortex",
          "epilepsy",
          "stroke",
          "thalamo",
          "basal ganglia",
          "hypothalamus",
          "auditory",
          "visual",
          "sensory",
          "motor",
          "cognition",
          "memory"
        ],
        "neurobiology": [
          "circuit",
          "development",
          "synaptic",
          "cellular",
          "molecular",
          "optogenetic",
          "neurobiology",
          "axon",
          "dendrite",
          "glia",
          "myelin",
          "neurotransmission",
          "synapse"
        ],
        "psychiatry": [
          "psychiatry",
          "mental health",
          "addiction",
          "autism",
          "schizophrenia",
          "depression",
          "anxiety",
          "bipolar",
          "drug addiction",
          "alcohol"
        ]
      },
      "tags": [
        "神经科学",
        "学术会议",
        "neuroscience",
        "conference"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"nature-conferences\",\n  \"parser\": \"nature-conferences\",\n  \"difficulty\": 1,\n  \"category\": \"学术会议\",\n  \"description\": \"Nature Reviews Neuroscience 推荐的神经科学学术会议列表\",\n  \"listPage\": {\n    \"containerSelector\": \"main\",\n    \"pagination\": {\n      \"enabled\": false\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"main, article, .content, #content\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".navigation\",\n        \".sidebar\",\n        \".cookie-banner\"\n      ],\n      \"trimWhitespace\": true,\n      \"removeEmptyLines\": true,\n      \"removeHtmlComments\": true\n    }\n  }\n}"
  },
  {
    "sourceId": "oncology_compass_events",
    "name": "Oncology Compass-Oncology Conferences",
    "siteName": "Oncology Compass",
    "channelName": "Oncology Conferences",
    "adapterKey": "oncology-compass",
    "adapterDir": "oncology-compass",
    "baseUrl": "https://oncologycompass.com",
    "country": "INT",
    "url": "https://oncologycompass.com/api/v1/events",
    "category": "学术会议",
    "description": "Oncology Compass 肿瘤学会议列表",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/api/v1/events · 入库分类标签 6 项（oncology、cancer…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 1",
      "priority": 1,
      "path": "/api/v1/events",
      "tags": [
        "oncology",
        "cancer",
        "conference",
        "congress",
        "肿瘤学",
        "会议"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"oncology-compass\",\n  \"parser\": \"oncology-compass\",\n  \"difficulty\": 1,\n  \"category\": \"学术会议\",\n  \"description\": \"Oncology Compass 肿瘤学会议列表\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": false\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"list-as-detail\"\n  }\n}"
  },
  {
    "sourceId": "prnewswire_fda-approval",
    "name": "PR Newswire-FDA Approval",
    "siteName": "PR Newswire",
    "channelName": "FDA Approval",
    "adapterKey": "prnewswire",
    "adapterDir": "prnewswire",
    "baseUrl": "https://www.prnewswire.com",
    "country": "Global",
    "url": "https://www.prnewswire.com/news-releases/health-latest-news/fda-approval-list/",
    "category": "新闻资讯",
    "description": "FDA 审批相关新闻（药品、医疗器械审批）",
    "crawlMode": "keyword_search",
    "crawlModeLabel": "关键词检索",
    "crawlModeSummary": "在新闻/数据库站点按多个关键词搜索后采集",
    "crawlModeDetail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths",
      "keywords"
    ],
    "configSummary": "栏目路径：/news-releases/health-la…",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "keywords",
        "group": "search",
        "type": "tags",
        "label": "搜索关键词",
        "specific": true,
        "description": "搜索关键词"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 0",
      "priority": 5,
      "path": "/news-releases/health-latest-news/fda-approval-list/",
      "maxPages": 20,
      "listPage": {
        "pagination": {
          "startPage": 1,
          "pageSize": 100
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "keywords": []
    },
    "readOnlyPreview": "{\n  \"adapter\": \"prnewswire\",\n  \"difficulty\": 1,\n  \"category\": \"新闻资讯\",\n  \"description\": \"FDA 审批相关新闻（药品、医疗器械审批）\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 100,\n      \"startPage\": 1,\n      \"maxPages\": 20\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"article, .release-body, .release-content, .bw-release-story\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".cookie-banner\",\n        \".share-buttons\",\n        \".related-news\",\n        \".pagination\",\n        \"[role=\\\"navigation\\\"]\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "prnewswire_international-medical-approval",
    "name": "PR Newswire-International Medical Approval",
    "siteName": "PR Newswire",
    "channelName": "International Medical Approval",
    "adapterKey": "prnewswire",
    "adapterDir": "prnewswire",
    "baseUrl": "https://www.prnewswire.com",
    "country": "Global",
    "url": "https://www.prnewswire.com/news-releases/health-latest-news/international-medical-approval-list/",
    "category": "新闻资讯",
    "description": "国际医疗审批新闻（CE、TFDA等）",
    "crawlMode": "keyword_search",
    "crawlModeLabel": "关键词检索",
    "crawlModeSummary": "在新闻/数据库站点按多个关键词搜索后采集",
    "crawlModeDetail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths",
      "keywords"
    ],
    "configSummary": "栏目路径：/news-releases/health-la…",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "keywords",
        "group": "search",
        "type": "tags",
        "label": "搜索关键词",
        "specific": true,
        "description": "搜索关键词"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * 0",
      "priority": 4,
      "path": "/news-releases/health-latest-news/international-medical-approval-list/",
      "maxPages": 20,
      "listPage": {
        "pagination": {
          "startPage": 1,
          "pageSize": 100
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "keywords": []
    },
    "readOnlyPreview": "{\n  \"adapter\": \"prnewswire\",\n  \"difficulty\": 1,\n  \"category\": \"新闻资讯\",\n  \"description\": \"国际医疗审批新闻（CE、TFDA等）\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 100,\n      \"startPage\": 1,\n      \"maxPages\": 20\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"article, .release-body, .release-content, .bw-release-story\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".cookie-banner\",\n        \".share-buttons\",\n        \".related-news\",\n        \".pagination\",\n        \"[role=\\\"navigation\\\"]\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "prnewswire_medical-equipment",
    "name": "PR Newswire-Medical Equipment",
    "siteName": "PR Newswire",
    "channelName": "Medical Equipment",
    "adapterKey": "prnewswire",
    "adapterDir": "prnewswire",
    "baseUrl": "https://www.prnewswire.com",
    "country": "Global",
    "url": "https://www.prnewswire.com/news-releases/health-latest-news/medical-equipment-list/",
    "category": "新闻资讯",
    "description": "医疗设备新闻",
    "crawlMode": "keyword_search",
    "crawlModeLabel": "关键词检索",
    "crawlModeSummary": "在新闻/数据库站点按多个关键词搜索后采集",
    "crawlModeDetail": "如 Business Wire、GlobeNewswire。关键词列表决定搜索范围，可配合时间、页数限制。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths",
      "keywords"
    ],
    "configSummary": "栏目路径：/news-releases/health-la…",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "dataRange.recentMonths",
        "group": "crawl",
        "type": "number",
        "label": "采集最近月数",
        "specific": false,
        "description": "采集最近月数"
      },
      {
        "key": "keywords",
        "group": "search",
        "type": "tags",
        "label": "搜索关键词",
        "specific": true,
        "description": "搜索关键词"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 0",
      "priority": 3,
      "path": "/news-releases/health-latest-news/medical-equipment-list/",
      "maxPages": 20,
      "listPage": {
        "pagination": {
          "startPage": 1,
          "pageSize": 100
        }
      },
      "dataRange": {
        "recentMonths": 12
      },
      "keywords": []
    },
    "readOnlyPreview": "{\n  \"adapter\": \"prnewswire\",\n  \"difficulty\": 1,\n  \"category\": \"新闻资讯\",\n  \"description\": \"医疗设备新闻\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 100,\n      \"startPage\": 1,\n      \"maxPages\": 20\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"readability\",\n    \"fallbackSelector\": \"article, .release-body, .release-content, .bw-release-story\",\n    \"cleanRules\": {\n      \"removeSelectors\": [\n        \"script\",\n        \"style\",\n        \"iframe\",\n        \"nav\",\n        \"header\",\n        \"footer\",\n        \".cookie-banner\",\n        \".share-buttons\",\n        \".related-news\",\n        \".pagination\",\n        \"[role=\\\"navigation\\\"]\"\n      ]\n    }\n  }\n}"
  },
  {
    "sourceId": "pubmed_device_literature",
    "name": "PubMed-医疗器械文献",
    "siteName": "PubMed",
    "channelName": "医疗器械文献",
    "adapterKey": "pubmed",
    "adapterDir": "pubmed",
    "baseUrl": "https://eutils.ncbi.nlm.nih.gov/entrez/eutils",
    "country": "US",
    "url": "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esearch.fcgi",
    "category": "学术文献",
    "description": "医疗器械/诊断设备相关的神经、肿瘤、呼吸等领域文献（近24个月）",
    "crawlMode": "literature_search",
    "crawlModeLabel": "文献检索",
    "crawlModeSummary": "按主题词、必含词、排除词检索学术论文",
    "crawlModeDetail": "如 PubMed、Springer。主题词 OR、必含 AND、排除 NOT 组合成检索式。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchTerms.topics",
      "searchTerms.include",
      "searchTerms.exclude",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/esearch.fcgi · 主题词 (OR) 12 项（Neurology、\"Neurological Diseases\"…） · 必须包含 (AND)：device、Diagnostic",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "searchTerms.topics",
        "group": "search",
        "type": "tags",
        "label": "主题词 (OR)",
        "specific": true,
        "description": "主题词 (OR)"
      },
      {
        "key": "searchTerms.include",
        "group": "search",
        "type": "tags",
        "label": "必须包含 (AND)",
        "specific": true,
        "description": "必须包含 (AND)"
      },
      {
        "key": "searchTerms.exclude",
        "group": "search",
        "type": "tags",
        "label": "排除词 (NOT)",
        "specific": true,
        "description": "排除词 (NOT)"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 2 * * 1",
      "priority": 1,
      "path": "/esearch.fcgi",
      "listPage": {
        "pagination": {
          "startPage": 0,
          "pageSize": 100
        }
      },
      "searchTerms": {
        "topics": [
          "Neurology",
          "\"Neurological Diseases\"",
          "epilepsy",
          "\"Parkinson disease\"",
          "cancer",
          "neoplasm",
          "tumour",
          "oncology",
          "respiratory",
          "COPD",
          "aesthetic",
          "infection"
        ],
        "include": [
          "device",
          "Diagnostic"
        ],
        "exclude": [
          "drug",
          "pharmacology",
          "placebo",
          "dosing"
        ]
      },
      "tags": [
        "medical device",
        "diagnostic",
        "neurology",
        "oncology",
        "respiratory",
        "pubmed"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"pubmed\",\n  \"parser\": \"pubmed\",\n  \"difficulty\": 1,\n  \"category\": \"学术文献\",\n  \"description\": \"医疗器械/诊断设备相关的神经、肿瘤、呼吸等领域文献（近24个月）\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 100,\n      \"startPage\": 0\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"api\"\n  }\n}"
  },
  {
    "sourceId": "springer_openaccess_device",
    "name": "Springer Nature Open Access-医疗器械 Open Access 文献",
    "siteName": "Springer Nature Open Access",
    "channelName": "医疗器械 Open Access 文献",
    "adapterKey": "springer",
    "adapterDir": "springer",
    "baseUrl": "https://api.springernature.com",
    "country": "DE",
    "url": "https://api.springernature.com/openaccess/json",
    "category": "学术文献",
    "description": "医疗器械/诊断设备相关的神经、肿瘤、呼吸等领域 Open Access 文献（近24个月）",
    "crawlMode": "literature_search",
    "crawlModeLabel": "文献检索",
    "crawlModeSummary": "按主题词、必含词、排除词检索学术论文",
    "crawlModeDetail": "如 PubMed、Springer。主题词 OR、必含 AND、排除 NOT 组合成检索式。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchTerms.topics",
      "searchTerms.include",
      "searchTerms.exclude",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/openaccess/json · 主题词 (OR) 12 项（Neurology、\"Neurological Diseases\"…） · 必须包含 (AND)：device、Diagnostic",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "maxPages",
        "group": "crawl",
        "type": "number",
        "label": "最大爬取页数",
        "specific": false,
        "description": "最大爬取页数"
      },
      {
        "key": "listPage.pagination.startPage",
        "group": "crawl",
        "type": "number",
        "label": "起始页码",
        "specific": false,
        "description": "起始页码"
      },
      {
        "key": "listPage.pagination.pageSize",
        "group": "crawl",
        "type": "number",
        "label": "每页条数",
        "specific": false,
        "description": "每页条数"
      },
      {
        "key": "searchTerms.topics",
        "group": "search",
        "type": "tags",
        "label": "主题词 (OR)",
        "specific": true,
        "description": "主题词 (OR)"
      },
      {
        "key": "searchTerms.include",
        "group": "search",
        "type": "tags",
        "label": "必须包含 (AND)",
        "specific": true,
        "description": "必须包含 (AND)"
      },
      {
        "key": "searchTerms.exclude",
        "group": "search",
        "type": "tags",
        "label": "排除词 (NOT)",
        "specific": true,
        "description": "排除词 (NOT)"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 3 * * *",
      "priority": 1,
      "path": "/openaccess/json",
      "maxPages": 100,
      "listPage": {
        "pagination": {
          "startPage": 500,
          "pageSize": 25
        }
      },
      "searchTerms": {
        "topics": [
          "Neurology",
          "\"Neurological Diseases\"",
          "epilepsy",
          "\"Parkinson disease\"",
          "cancer",
          "neoplasm",
          "tumour",
          "oncology",
          "respiratory",
          "COPD",
          "aesthetic",
          "infection"
        ],
        "include": [
          "device",
          "Diagnostic"
        ],
        "exclude": [
          "drug",
          "pharmacology",
          "placebo",
          "dosing"
        ]
      },
      "tags": [
        "medical device",
        "diagnostic",
        "neurology",
        "oncology",
        "respiratory",
        "springer",
        "open access"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"springer\",\n  \"parser\": \"springer\",\n  \"difficulty\": 1,\n  \"category\": \"学术文献\",\n  \"description\": \"医疗器械/诊断设备相关的神经、肿瘤、呼吸等领域 Open Access 文献（近24个月）\",\n  \"listPage\": {\n    \"pagination\": {\n      \"enabled\": true,\n      \"pageSize\": 25,\n      \"startPage\": 500,\n      \"maxPages\": 100\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"api\"\n  }\n}"
  },
  {
    "sourceId": "aesthetic_society_meetings_meetings",
    "name": "The Aesthetic Society Meetings-Aesthetic Society Meetings",
    "siteName": "The Aesthetic Society Meetings",
    "channelName": "Aesthetic Society Meetings",
    "adapterKey": "aesthetic-society-meetings",
    "adapterDir": "aesthetic-society-meetings",
    "baseUrl": "https://www.theaestheticsociety.org",
    "country": "US",
    "url": "https://www.theaestheticsociety.org/medical-professionals/meetings",
    "category": "学术会议",
    "description": "The Aesthetic Society 美容整形外科学会会议列表",
    "crawlMode": "list_page",
    "crawlModeLabel": "栏目列表",
    "crawlModeSummary": "打开固定栏目页，翻页抓取列表中的文章链接",
    "crawlModeDetail": "不依赖关键词检索。爬虫按栏目 URL 一页页读列表，进入详情页取正文。可调：启用、时间、页数、时间范围。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "maxPages",
      "dataRange.recentMonths"
    ],
    "configSummary": "栏目路径：/medical-professionals/m… · 入库分类标签 5 项（美容整形、整形外科…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "path",
        "group": "search",
        "type": "string",
        "label": "栏目路径",
        "specific": true,
        "description": "栏目路径"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 6 * * 1",
      "priority": 1,
      "path": "/medical-professionals/meetings",
      "tags": [
        "美容整形",
        "整形外科",
        "aesthetic surgery",
        "plastic surgery",
        "conference"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"aesthetic-society-meetings\",\n  \"parser\": \"aesthetic-society-meetings\",\n  \"difficulty\": 1,\n  \"category\": \"学术会议\",\n  \"description\": \"The Aesthetic Society 美容整形外科学会会议列表\",\n  \"listPage\": {\n    \"containerSelector\": \".meeting-card-list\",\n    \"itemSelector\": \"article.meeting-event\",\n    \"titleSelector\": \"h5\",\n    \"linkSelector\": \".card-body a[href]\",\n    \"dateSelector\": \".duration.card-header\",\n    \"locationSelector\": \".meeting-event__body p\",\n    \"registrationSelector\": \".links a[aria-label=\\\"Meeting registration\\\"]\",\n    \"overviewSelector\": \".links a[aria-label=\\\"Meeting overview\\\"]\",\n    \"pagination\": {\n      \"enabled\": false\n    }\n  },\n  \"detailPage\": {\n    \"mode\": \"list-as-detail\"\n  }\n}"
  },
  {
    "sourceId": "who_ictrp_device-trials",
    "name": "WHO ICTRP (International Clinical Trials Registry Platform)-WHO ICTRP - Device Trials",
    "siteName": "WHO ICTRP (International Clinical Trials Registry Platform)",
    "channelName": "WHO ICTRP - Device Trials",
    "adapterKey": "who-ictrp",
    "adapterDir": "who-ictrp",
    "baseUrl": "https://trialsearch.who.int",
    "country": "EU",
    "url": "https://trialsearch.who.int",
    "category": "ClinicalTrials-临床试验",
    "description": "WHO ICTRP 医疗器械类临床试验 (COPD, Parkinson, Epilepsy, Stroke 等)",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "标题关键词（2 项） · 招募状态：Recruiting · 入库分类标签 6 项（WHO、ICTRP…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.titleKeywords",
        "group": "search",
        "type": "json",
        "label": "标题关键词",
        "specific": true,
        "description": "标题关键词"
      },
      {
        "key": "searchConfig.recruitmentStatus",
        "group": "search",
        "type": "string",
        "label": "招募状态",
        "specific": true,
        "description": "招募状态"
      },
      {
        "key": "searchConfig.dateRange.recentMonths",
        "group": "search",
        "type": "number",
        "label": "最近月数",
        "specific": true,
        "description": "最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 4 * * 0",
      "priority": 1,
      "searchConfig": {
        "titleKeywords": {
          "device-trials": [
            "Chronic Obstructive Pulmonary Disease",
            "COPD",
            "Essential Tremor",
            "ET",
            "Alzheimer's Disease",
            "AD",
            "Parkinson's Disease",
            "PD",
            "Depressive Disorder",
            "Depression",
            "Obsessive-Compulsive Disorder",
            "OCD",
            "Asthma",
            "Sleep Apnea",
            "Obstructive Sleep Apnea",
            "Pulmonary Fibrosis",
            "Lung Nodule",
            "Epilepsy",
            "Stroke",
            "Neurodegenerative Diseases",
            "Psychiatric Disorders",
            "Pigment Therapy",
            "Skin Rejuvenation",
            "Facial Fillers"
          ],
          "diagnostic-trials": [
            "Cancer",
            "tumor",
            "Alzheimer's Disease",
            "Parkinson's Disease",
            "Depressive Disorder",
            "Depression",
            "Neurodegenerative",
            "Respiratory Infection",
            "Influenza",
            "COVID-19",
            "Tuberculosis",
            "Human Immunodeficiency Virus",
            "HIV",
            "Hepatitis B",
            "Sepsis",
            "Multidrug Resistance",
            "Antimicrobial Resistance"
          ]
        },
        "recruitmentStatus": "Recruiting",
        "dateRange": {
          "recentMonths": 60
        }
      },
      "tags": [
        "WHO",
        "ICTRP",
        "clinical trial",
        "device",
        "medical device",
        "international"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"who-ictrp\",\n  \"difficulty\": 3,\n  \"type\": \"html\",\n  \"category\": \"ClinicalTrials-临床试验\",\n  \"description\": \"WHO ICTRP 医疗器械类临床试验 (COPD, Parkinson, Epilepsy, Stroke 等)\",\n  \"listPage\": {\n    \"resultCountSelector\": \"span:contains(\\\"records for\\\")\",\n    \"tableSelector\": \"#ctl00_ContentPlaceHolder1_GridViewSearch\",\n    \"rowSelector\": \"tr\",\n    \"columnMapping\": {\n      \"recruitmentStatus\": 0,\n      \"prospective\": 1,\n      \"mainId\": 2,\n      \"publicTitle\": 3,\n      \"dateOfRegistration\": 4,\n      \"resultsAvailable\": 5\n    },\n    \"trialLinkSelector\": \"a[href*=\\\"Trial2.aspx\\\"]\",\n    \"paginationSelector\": \"a[href*=\\\"lnkPageNo\\\"]\",\n    \"lastPageSelector\": \"a:contains(\\\"Last\\\")\",\n    \"recordsPerPage\": 100\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"fields\": {\n      \"mainId\": \"td:contains(\\\"Main ID:\\\") + td\",\n      \"scientificTitle\": \"td:contains(\\\"Scientific title:\\\") + td\",\n      \"primarySponsor\": \"td:contains(\\\"Primary sponsor:\\\") + td\",\n      \"healthConditions\": \"td:contains(\\\"Health Condition(s)\\\") ~ td\",\n      \"interventions\": \"td:contains(\\\"Intervention(s)\\\") ~ td\",\n      \"phase\": \"td:contains(\\\"Phase:\\\") + td\",\n      \"dateOfFirstEnrolment\": \"td:contains(\\\"Date of first enrolment:\\\") + td\",\n      \"dateOfRegistration\": \"td:contains(\\\"Date of registration:\\\") + td\",\n      \"dateOfCompletion\": \"td:contains(\\\"Date of completion:\\\") + td\",\n      \"register\": \"td:contains(\\\"Register:\\\") + td\",\n      \"url\": \"td:contains(\\\"URL:\\\") + td a\",\n      \"primaryOutcomes\": \"td:contains(\\\"Primary Outcome(s)\\\") ~ td\",\n      \"publicTitle\": \"td:contains(\\\"Public title:\\\") + td\",\n      \"recruitmentStatus\": \"td:contains(\\\"Recruitment status:\\\") + td\",\n      \"studyType\": \"td:contains(\\\"Study type:\\\") + td\",\n      \"targetSampleSize\": \"td:contains(\\\"Target sample size:\\\") + td\",\n      \"countries\": \"td:contains(\\\"Countries of recruitment\\\") ~ td\",\n      \"lastRefreshed\": \"td:contains(\\\"Last refreshed on:\\\") + td\"\n    }\n  }\n}"
  },
  {
    "sourceId": "who_ictrp_diagnostic-trials",
    "name": "WHO ICTRP (International Clinical Trials Registry Platform)-WHO ICTRP - Diagnostic Trials",
    "siteName": "WHO ICTRP (International Clinical Trials Registry Platform)",
    "channelName": "WHO ICTRP - Diagnostic Trials",
    "adapterKey": "who-ictrp",
    "adapterDir": "who-ictrp",
    "baseUrl": "https://trialsearch.who.int",
    "country": "EU",
    "url": "https://trialsearch.who.int",
    "category": "ClinicalTrials-临床试验",
    "description": "WHO ICTRP 诊断类临床试验 (Cancer, HIV, COVID-19, Tuberculosis 等)",
    "crawlMode": "api_search",
    "crawlModeLabel": "API 检索",
    "crawlModeSummary": "调用网站开放接口，按检索条件返回 JSON 数据",
    "crawlModeDetail": "如 ClinicalTrials、WHO ICTRP。检索条件（疾病、干预类型、状态等）决定抓哪些记录。",
    "opsFieldKeys": [
      "enabled",
      "schedule",
      "searchConfig.keywords",
      "searchConfig.conditions",
      "searchConfig.interventionTypes",
      "searchConfig.statuses",
      "dataRange.recentMonths"
    ],
    "configSummary": "标题关键词（2 项） · 招募状态：Recruiting · 入库分类标签 6 项（WHO、ICTRP…）",
    "paramSchema": [
      {
        "key": "enabled",
        "group": "ops",
        "type": "boolean",
        "label": "启用频道",
        "specific": false,
        "description": "启用频道"
      },
      {
        "key": "schedule",
        "group": "ops",
        "type": "cron",
        "label": "Cron 定时",
        "specific": false,
        "description": "Cron 定时"
      },
      {
        "key": "priority",
        "group": "ops",
        "type": "number",
        "label": "队列优先级",
        "specific": false,
        "description": "队列优先级"
      },
      {
        "key": "searchConfig.titleKeywords",
        "group": "search",
        "type": "json",
        "label": "标题关键词",
        "specific": true,
        "description": "标题关键词"
      },
      {
        "key": "searchConfig.recruitmentStatus",
        "group": "search",
        "type": "string",
        "label": "招募状态",
        "specific": true,
        "description": "招募状态"
      },
      {
        "key": "searchConfig.dateRange.recentMonths",
        "group": "search",
        "type": "number",
        "label": "最近月数",
        "specific": true,
        "description": "最近月数"
      },
      {
        "key": "tags",
        "group": "meta",
        "type": "tags",
        "label": "入库分类标签",
        "specific": true,
        "description": "入库分类标签"
      }
    ],
    "paramGroups": {
      "ops": "运维",
      "crawl": "抓取量",
      "search": "搜索与过滤",
      "meta": "元数据"
    },
    "baselineConfig": {
      "enabled": true,
      "schedule": "0 5 * * 0",
      "priority": 1,
      "searchConfig": {
        "titleKeywords": {
          "device-trials": [
            "Chronic Obstructive Pulmonary Disease",
            "COPD",
            "Essential Tremor",
            "ET",
            "Alzheimer's Disease",
            "AD",
            "Parkinson's Disease",
            "PD",
            "Depressive Disorder",
            "Depression",
            "Obsessive-Compulsive Disorder",
            "OCD",
            "Asthma",
            "Sleep Apnea",
            "Obstructive Sleep Apnea",
            "Pulmonary Fibrosis",
            "Lung Nodule",
            "Epilepsy",
            "Stroke",
            "Neurodegenerative Diseases",
            "Psychiatric Disorders",
            "Pigment Therapy",
            "Skin Rejuvenation",
            "Facial Fillers"
          ],
          "diagnostic-trials": [
            "Cancer",
            "tumor",
            "Alzheimer's Disease",
            "Parkinson's Disease",
            "Depressive Disorder",
            "Depression",
            "Neurodegenerative",
            "Respiratory Infection",
            "Influenza",
            "COVID-19",
            "Tuberculosis",
            "Human Immunodeficiency Virus",
            "HIV",
            "Hepatitis B",
            "Sepsis",
            "Multidrug Resistance",
            "Antimicrobial Resistance"
          ]
        },
        "recruitmentStatus": "Recruiting",
        "dateRange": {
          "recentMonths": 60
        }
      },
      "tags": [
        "WHO",
        "ICTRP",
        "clinical trial",
        "diagnostic",
        "diagnosis",
        "international"
      ]
    },
    "readOnlyPreview": "{\n  \"adapter\": \"who-ictrp\",\n  \"difficulty\": 3,\n  \"type\": \"html\",\n  \"category\": \"ClinicalTrials-临床试验\",\n  \"description\": \"WHO ICTRP 诊断类临床试验 (Cancer, HIV, COVID-19, Tuberculosis 等)\",\n  \"listPage\": {\n    \"resultCountSelector\": \"span:contains(\\\"records for\\\")\",\n    \"tableSelector\": \"#ctl00_ContentPlaceHolder1_GridViewSearch\",\n    \"rowSelector\": \"tr\",\n    \"columnMapping\": {\n      \"recruitmentStatus\": 0,\n      \"prospective\": 1,\n      \"mainId\": 2,\n      \"publicTitle\": 3,\n      \"dateOfRegistration\": 4,\n      \"resultsAvailable\": 5\n    },\n    \"trialLinkSelector\": \"a[href*=\\\"Trial2.aspx\\\"]\",\n    \"paginationSelector\": \"a[href*=\\\"lnkPageNo\\\"]\",\n    \"lastPageSelector\": \"a:contains(\\\"Last\\\")\",\n    \"recordsPerPage\": 100\n  },\n  \"detailPage\": {\n    \"mode\": \"selector\",\n    \"fields\": {\n      \"mainId\": \"td:contains(\\\"Main ID:\\\") + td\",\n      \"scientificTitle\": \"td:contains(\\\"Scientific title:\\\") + td\",\n      \"primarySponsor\": \"td:contains(\\\"Primary sponsor:\\\") + td\",\n      \"healthConditions\": \"td:contains(\\\"Health Condition(s)\\\") ~ td\",\n      \"interventions\": \"td:contains(\\\"Intervention(s)\\\") ~ td\",\n      \"phase\": \"td:contains(\\\"Phase:\\\") + td\",\n      \"dateOfFirstEnrolment\": \"td:contains(\\\"Date of first enrolment:\\\") + td\",\n      \"dateOfRegistration\": \"td:contains(\\\"Date of registration:\\\") + td\",\n      \"dateOfCompletion\": \"td:contains(\\\"Date of completion:\\\") + td\",\n      \"register\": \"td:contains(\\\"Register:\\\") + td\",\n      \"url\": \"td:contains(\\\"URL:\\\") + td a\",\n      \"primaryOutcomes\": \"td:contains(\\\"Primary Outcome(s)\\\") ~ td\",\n      \"publicTitle\": \"td:contains(\\\"Public title:\\\") + td\",\n      \"recruitmentStatus\": \"td:contains(\\\"Recruitment status:\\\") + td\",\n      \"studyType\": \"td:contains(\\\"Study type:\\\") + td\",\n      \"targetSampleSize\": \"td:contains(\\\"Target sample size:\\\") + td\",\n      \"countries\": \"td:contains(\\\"Countries of recruitment\\\") ~ td\",\n      \"lastRefreshed\": \"td:contains(\\\"Last refreshed on:\\\") + td\"\n    }\n  }\n}"
  }
]

export function getSourceDetail(sourceId) {
  return SOURCE_LIST_ITEMS.find((item) => item.sourceId === sourceId) || null
}

export function getParamSchema(sourceId) {
  return getSourceDetail(sourceId)?.paramSchema || []
}

export function getDefaultConfig(sourceId) {
  const detail = getSourceDetail(sourceId)
  return detail?.baselineConfig ? JSON.parse(JSON.stringify(detail.baselineConfig)) : {}
}

export function getReadOnlyPreview(sourceId) {
  return getSourceDetail(sourceId)?.readOnlyPreview || ''
}

export function getCrawlModeStats() {
  const stats = {}
  for (const item of SOURCE_LIST_ITEMS) {
    stats[item.crawlMode] = (stats[item.crawlMode] || 0) + 1
  }
  return stats
}
